import { defineComponent as $, useSlots as Nr, computed as E, openBlock as x, createElementBlock as I, normalizeClass as k, createElementVNode as L, createBlock as P, unref as f, Fragment as he, renderSlot as R, createCommentVNode as z, ref as T, shallowRef as Na, watch as q, shallowReadonly as Dn, reactive as ze, inject as ye, toRefs as ue, provide as Ae, onMounted as At, onUnmounted as Rr, resolveDynamicComponent as lr, withCtx as V, createTextVNode as Q, toDisplayString as ee, mergeProps as ne, Transition as Pr, createVNode as j, h as K, getCurrentScope as Nn, onScopeDispose as Rn, toRef as Pn, readonly as Mn, customRef as Ra, isRef as Ye, nextTick as Mr, getCurrentInstance as Pa, watchEffect as zn, useAttrs as Vn, toHandlers as qn, withModifiers as Xe, normalizeStyle as Ce, Teleport as zr, withDirectives as Vr, vModelRadio as Hn, isVNode as Cr, renderList as Ge, createApp as Fn, cloneVNode as Wn, vShow as Ma, onBeforeUnmount as jn, normalizeProps as Un, render as Yn } from "vue";
const Xn = "rounded-md px-3 flex items-center justify-center duration-150 transition-colors border focus:outline-none disabled:cursor-not-allowed", Gn = {
  mini: "h-6 text-o",
  xsmall: "h-8 text-o",
  small: "h-10 text-b",
  middle: "h-12 text-b",
  large: "h-14 text-h2"
}, Kn = {
  fill: "disabled:bg-disable-matt disabled:text-disable-matt",
  outline: "disabled:border-disable-matt disabled:text-disable-bright",
  flat: "disabled:bg-disable-matt disabled:text-disable-matt",
  plain: "disabled:text-disable-bright"
}, Zn = {
  green: "bg-brand-primary text-neutral-quaternary active:bg-brand-primary-press md:hover:enabled:bg-brand-primary-hover text-neutral-quaternary border-transparent",
  red: "bg-critical-primary text-neutral-quaternary active:bg-critical-primary-press active:text-neutral-quaternary-press md:hover:enabled:bg-critical-primary-hover md:hover:enabled:text-neutral-quaternary-hover border-transparent",
  gray: "bg-neutral-quinary text-neutral-primary active:bg-neutral-quinary-press active:text-neutral-primary-press md:hover:enabled:bg-neutral-quinary-hover md:hover:enabled:text-neutral-primary-hover border-transparent"
}, Qn = {
  green: "text-brand-primary border-brand-primary active:text-brand-primary-press active:border-brand-primary-press md:hover:enabled:border-brand-primary-hover md:hover:enabled:text-brand-primary-hover",
  red: "text-critical-primary border-critical-primary active:text-critical-primary-press active:border-critical-primary-press md:hover:enabled:border-critical-primary-hover md:hover:enabled:text-critical-primary-hover",
  gray: "text-neutral-secondary border-neutral-quaternary active:text-neutral-secondary-press active:border-neutral-quaternary-press md:hover:border-neutral-quaternary-hover md:hover:enabled:text-neutral-secondary-hover"
}, Jn = {
  green: "bg-brand-secondary text-brand-quaternary md:hover:enabled:bg-brand-secondary-hover md:hover:enabled:text-brand-quaternary active:bg-brand-secondary-press active:text-brand-quaternary-press border-transparent",
  red: "bg-critical-secondary text-critical-secondary md:hover:enabled:bg-critical-secondary-hover md:hover:enabled:text-critical-secondary-hover active:bg-critical-secondary-press active:text-critical-secondary border-transparent",
  gray: "bg-neutral-quinary text-neutral-primary md:hover:enabled:bg-neutral-quinary-hover md:hover:enabled:text-neutral-primary-hover active:bg-neutral-quinary-press active:text-neutral-primary border-transparent"
}, eo = {
  green: "text-brand-primary active:text-brand-primary-press border-transparent",
  red: "text-critical-primary active:text-critical-primary-press border-transparent",
  gray: "text-neutral-primary active:text-neutral-primary-press border-transparent"
}, to = {
  default: "pointer-events-none cursor-not-allowed"
}, ro = { class: "inline-flex items-center justify-between" }, ao = {
  key: 0,
  class: "me-1 rtl:-mr-1 ltr:-ml-1"
}, no = $({ name: "NButton" }), dt = /* @__PURE__ */ $({
  ...no,
  props: {
    size: { default: "middle" },
    variant: { default: "fill" },
    color: { default: "green" },
    loading: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, r = Nr(), a = E(() => [
      Xn,
      Gn[t.size],
      Kn[t.variant],
      t.variant === "fill" && Zn[t.color],
      t.variant === "flat" && Jn[t.color],
      t.variant === "plain" && eo[t.color],
      t.variant === "outline" && Qn[t.color],
      t.loading && to.default,
      {
        "rounded-xl": t.size === "mini"
      }
    ]);
    return (n, o) => (x(), I("button", {
      class: k(a.value)
    }, [
      L("div", ro, [
        n.loading ? (x(), P(f(ke), {
          key: 0,
          size: 10,
          class: "mx-auto"
        })) : (x(), I(he, { key: 1 }, [
          f(r).icon ? (x(), I("div", ao, [
            R(n.$slots, "icon")
          ])) : z("", !0),
          R(n.$slots, "default")
        ], 64))
      ])
    ], 2));
  }
});
dt.install = (e) => {
  e.component(dt.name, dt);
};
function Pe() {
  const e = T(), t = () => {
    e.value = null;
  };
  return { trigger: (...n) => {
    e.value?.(...n);
  }, on: (n) => (e.value = n, { off: t }), off: t, callback: e };
}
function ir(e, t) {
  const r = Na(t);
  return q(
    e,
    (a) => {
      r.value = a;
    },
    { immediate: !0, deep: !0 }
  ), r;
}
function Fe(e) {
  return e && typeof e == "object" && "value" in e ? e.value : e;
}
function sr({
  initialState: e = void 0,
  syncStateFrom: t = T(),
  multiple: r = T(!1),
  mandatory: a = T(!1),
  isDisabled: n = () => !1,
  isEqual: o = (i, l) => i === l
}) {
  const i = ir(t, e), l = Pe(), s = Pe(), d = Pe(), u = () => {
    e !== void 0 ? r.value ? Array.isArray(e) ? i.value = [...e] : i.value = [] : Array.isArray(e) ? i.value = void 0 : i.value = e : r.value ? i.value = [] : i.value = void 0, d.trigger(i.value);
  };
  u(), q(r, u);
  const c = (m) => {
    n(m) || p(m) || (r.value && Array.isArray(i.value) ? i.value.push(m) : i.value = m, d.trigger(i.value), l.trigger(m));
  }, v = (m) => {
    if (!(n(m) || !p(m))) {
      if (r.value && Array.isArray(i.value)) {
        if (a.value && i.value.length <= 1)
          return;
        const h = i.value.findIndex(
          (w) => o(Fe(w), Fe(m))
        );
        i.value.splice(h, 1);
      } else if (!a.value)
        i.value = null;
      else
        return;
      d.trigger(i.value), s.trigger(m);
    }
  }, p = (m) => r.value && Array.isArray(i.value) ? i.value.some((h) => o(Fe(h), Fe(m))) : o(Fe(i.value), Fe(m)), b = (m) => {
    n(m) || (p(m) ? v(m) : c(m));
  };
  return {
    state: Dn(i),
    add: c,
    remove: v,
    toggle: b,
    isActive: p,
    onStateChange: d.on,
    onItemAdd: l.on,
    onItemRemove: s.on
  };
}
const oo = {
  listbox: {
    filter: "انتخاب‌ها را فیلتر کنید",
    no_matching_data: "آیتمی یافت نشد",
    select: "انتخاب کنید"
  },
  table: {
    noData: "داده‌ای موجود نیست",
    noResult: "نتیجه‌ای یافت نشد"
  },
  toast: {
    removeAll: "بستن همه"
  }
}, lo = {
  listbox: {
    filter: "Type to filter",
    no_matching_data: "No matching data",
    select: "Select"
  },
  table: {
    noData: "No data available",
    noResult: "No matching records found"
  },
  toast: {
    removeAll: "Remove All"
  }
}, gr = T("fa"), yr = ze({ fa: oo, en: lo }), qr = {
  messages() {
    return yr[gr.value];
  },
  getLocale() {
    return gr.value;
  },
  setLocale(e, t) {
    gr.value = e, !yr[e] && t && (yr[e] = t);
  }
}, io = {
  fa: "rtl",
  en: "ltr"
}, so = {
  rtl: "ltr",
  ltr: "rtl"
};
function za() {
  const e = E(() => io[qr.getLocale()]), t = E(
    () => so[e.value]
  );
  return {
    direction: e,
    oppositeDirection: t
  };
}
var Y = /* @__PURE__ */ ((e) => (e.ArrowUp = "ArrowUp", e.ArrowDown = "ArrowDown", e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e.Escape = "Escape", e.Enter = "Enter", e))(Y || {});
function $r(e, t = 0) {
  const { shouldIgnoreIndex: r, currentIndex: a, total: n } = e, o = a + 1 + t;
  return o >= n - 1 ? n - 1 : typeof r == "function" && r(o) ? $r(e, t + 1) : o;
}
function Tr(e, t = 0) {
  const { shouldIgnoreIndex: r, currentIndex: a } = e, n = a - 1 + t;
  return n <= 0 ? 0 : typeof r == "function" && r(n) ? Tr(e, t - 1) : n;
}
function Ve(e) {
  return {
    ArrowDown: $r,
    ArrowUp: Tr,
    ArrowRight: $r,
    ArrowLeft: Tr
  }[e];
}
const Va = Symbol("ButtonToggleContext");
function uo() {
  const e = ye(Va);
  if (!e)
    throw new Error(
      "The useButtonToggleContext hook must be used within <ButtonToggle /> component."
    );
  return e;
}
function co(e, t) {
  const { autoActivate: r, color: a, modelValue: n } = ue(t), {
    isActive: o,
    add: i,
    onStateChange: l
  } = sr({
    initialState: t.modelValue,
    syncStateFrom: n,
    mandatory: T(!0)
  }), { direction: s } = za();
  function d(p, b) {
    const m = e.value.findIndex(
      (w) => p === w.element
    ), h = Ve(b)({
      currentIndex: m,
      total: e.value.length,
      shouldIgnoreIndex(w) {
        return e.value[w].disabled;
      }
    });
    e.value[h].element?.focus();
  }
  function u(p, b) {
    const m = e.value.findIndex(
      (w) => p === w.element
    ), h = Ve(b)({
      currentIndex: m,
      total: e.value.length,
      shouldIgnoreIndex(w) {
        return e.value[w].disabled;
      }
    });
    e.value[h].element?.focus(), i(h);
  }
  function c({ target: p, code: b }) {
    const m = {
      rtl: {
        [Y.ArrowLeft]: Y.ArrowRight,
        [Y.ArrowRight]: Y.ArrowLeft
      }
    }[s.value]?.[b] || b, h = r.value ? u : d, w = {
      [Y.ArrowLeft]: () => h(p, m),
      [Y.ArrowRight]: () => h(p, m)
    };
    w[m] && w[m]();
  }
  return Ae(Va, {
    isButtonActive: o,
    activateButton: i,
    color: a
  }), {
    onActiveButtonChange: l,
    handleKeyDown: c
  };
}
let pa = 0;
function fo(e = "") {
  return pa += 1, `${e}${pa}`;
}
function Te(e) {
  return fo(e);
}
const qa = Symbol("DescendantsContext");
function po() {
  const e = ye(qa);
  if (!e)
    throw new Error(
      "useRegisterDescendant must be used within a parent with the usage of useDeepDescendants"
    );
  return e;
}
function ur(e) {
  const t = T(), r = Te(e.idPrefix), { descendants: a, register: n, unregister: o } = po();
  return At(() => {
    n({ element: f(t), ...e, id: r });
  }), Rr(() => {
    o(r);
  }), { index: E(
    () => a.value.findIndex((l) => l.id === r)
  ), ref: t, id: r };
}
function dr() {
  const e = T([]);
  function t(a) {
    e.value.push(a);
  }
  function r(a) {
    const n = e.value.findIndex(
      (o) => o.index === a
    );
    e.value.splice(n, 1);
  }
  return Ae(qa, { descendants: e, register: t, unregister: r }), { descendants: e };
}
const vo = "inline-flex rounded-3xl items-center justify-center h-5 gap-1 px-2 py-0.5 outline-none", va = {
  normal: {
    green: "bg-transparent text-brand-primary-press disabled:bg-brand-primary-disable disabled:text-neutral-tertiary-disable disabled:cursor-not-allowed active:bg-brand-primary-press md:hover:enabled:bg-brand-primary-hover md:hover:enabled:text-brand-secondary-hover",
    gray: "bg-transparent text-neutral-tertiary disabled:bg-neutral-secondary-disable disabled:text-neutral-secondary-disable disabled:cursor-not-allowed md:hover:enabled:text-neutral-secondary md:hover:enabled:bg-neutral-secondary active:bg-neutral-primary active:text-neutral-secondary-press"
  },
  active: {
    green: "bg-brand-primary-press text-brand-primary-disable",
    gray: "bg-neutral-primary text-neutral-secondary-press"
  }
};
var Ha = /* @__PURE__ */ ((e) => (e["3xl"] = "text-3xl", e["2xl"] = "text-2xl", e.xl = "text-xl", e.h1 = "text-h1", e.h2 = "text-h2", e.h3 = "text-h3", e.body = "text-b", e.subtitle = "text-s", e.caption1 = "text-c1", e.caption2 = "text-c2", e.overline = "text-o", e))(Ha || {}), Fa = /* @__PURE__ */ ((e) => (e.regular = "font-regular", e.medium = "font-medium", e.bold = "font-bold", e))(Fa || {});
const mo = $({ name: "NText" }), J = /* @__PURE__ */ $({
  ...mo,
  props: {
    variant: { default: "body" },
    tag: { default: "span" },
    weight: { default: "regular" }
  },
  setup(e) {
    const t = e, r = E(() => [Ha[t.variant], Fa[t.weight]]);
    return (a, n) => (x(), P(lr(t.tag), {
      class: k(r.value)
    }, {
      default: V(() => [
        R(a.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), ho = ["id", "buttonindex", "aria-selected"], bo = $({ name: "NButtonToggle" }), It = /* @__PURE__ */ $({
  ...bo,
  props: {
    modelValue: { default: 0 },
    label: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const r = e, { isButtonActive: a, activateButton: n, color: o } = uo(), {
      ref: i,
      index: l,
      id: s
    } = ur({ ...r, idPrefix: "button-" }), d = E(() => a(l.value));
    return (u, c) => (x(), I("button", {
      id: f(s),
      ref_key: "ref",
      ref: i,
      class: k([
        f(vo),
        d.value ? f(va).active[f(o)] : f(va).normal[f(o)]
      ]),
      type: "button",
      buttonindex: d.value ? 0 : -1,
      "aria-selected": d.value,
      onClick: c[0] || (c[0] = (v) => f(n)(f(l)))
    }, [
      R(u.$slots, "icon"),
      R(u.$slots, "label", {}, () => [
        u.label ? (x(), P(J, {
          key: 0,
          variant: "overline",
          weight: "medium"
        }, {
          default: V(() => [
            Q(ee(u.label), 1)
          ]),
          _: 1
        })) : z("", !0)
      ])
    ], 10, ho));
  }
});
It.install = (e) => {
  e.component(It.name, It);
};
const go = "inline-flex h-6 items-center px-0.5 gap-1 rounded-3xl group", yo = {
  green: "bg-brand-secondary",
  gray: "bg-neutral-quinary"
}, wo = $({ name: "NButtonToggleGroup" }), Dt = /* @__PURE__ */ $({
  ...wo,
  props: {
    modelValue: { default: 0 },
    label: { default: "" },
    disabled: { type: Boolean, default: !1 },
    color: { default: "green" },
    autoActivate: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const r = e, a = t, { descendants: n } = dr(), { onActiveButtonChange: o, handleKeyDown: i } = co(
      n,
      r
    );
    return o((l) => {
      a("update:modelValue", l);
    }), (l, s) => (x(), I("div", null, [
      L("div", ne({
        role: "group",
        class: [f(go), f(yo)[l.color]]
      }, l.$attrs), [
        R(l.$slots, "default")
      ], 16)
    ]));
  }
});
Dt.install = (e) => {
  e.component(Dt.name, Dt);
};
const xo = "flex justify-center items-center rounded-md duration-150 transition-colors border focus:outline-none disabled:cursor-not-allowed", _o = {
  mini: "h-6 w-6 px-1",
  xsmall: "h-8 w-8 px-1",
  small: "h-10 w-10 px-2",
  middle: "h-12 w-12 px-3",
  large: "h-14 w-14 px-3"
}, Ao = {
  fill: "disabled:bg-disable-matt disabled:text-disable-matt",
  outline: "disabled:border-disable-matt disabled:text-disable-bright",
  flat: "disabled:bg-disable-matt disabled:text-disable-matt",
  plain: "disabled:text-disable-bright"
}, Eo = {
  green: "bg-brand-primary text-neutral-quaternary active:bg-brand-primary-press md:hover:enabled:bg-brand-primary-hover text-neutral-quaternary border-transparent",
  red: "bg-critical-primary text-neutral-quaternary active:bg-critical-primary-press active:text-neutral-quaternary-press md:hover:enabled:bg-critical-primary-hover md:hover:enabled:text-neutral-quaternary-hover border-transparent",
  gray: "bg-neutral-quinary text-neutral-primary active:bg-neutral-quinary-press active:text-neutral-primary-press md:hover:enabled:bg-neutral-quinary-hover md:hover:enabled:text-neutral-primary-hover border-transparent"
}, So = {
  green: "text-brand-primary border-brand-primary active:text-brand-primary-press active:border-brand-primary-press md:hover:enabled:border-brand-primary-hover md:hover:enabled:text-brand-primary-hover",
  red: "text-critical-primary border-critical-primary active:text-critical-primary-press active:border-critical-primary-press md:hover:enabled:border-critical-primary-hover md:hover:enabled:text-critical-primary-hover",
  gray: "text-neutral-primary border-neutral-primary active:text-neutral-primary-press active:border-neutral-primary-press md:hover:enabled:border-neutral-primary-hover md:hover:enabled:text-neutral-primary-hover"
}, Co = {
  green: "bg-brand-secondary text-brand-quaternary md:hover:enabled:bg-brand-secondary-hover md:hover:enabled:text-brand-quaternary active:bg-brand-secondary-press active:text-brand-quaternary-press border-transparent",
  red: "bg-critical-secondary text-critical-secondary md:hover:enabled:bg-critical-secondary-hover md:hover:enabled:text-critical-secondary-hover active:bg-critical-secondary-press active:text-critical-secondary border-transparent",
  gray: "bg-neutral-quinary text-neutral-primary md:hover:enabled:bg-neutral-quinary-hover md:hover:enabled:text-neutral-primary-hover active:bg-neutral-quinary-press active:text-neutral-primary border-transparent"
}, $o = {
  green: "text-brand-primary active:text-brand-primary-press border-transparent",
  red: "text-critical-primary active:text-critical-primary-press border-transparent",
  gray: "text-neutral-primary active:text-neutral-primary-press border-transparent"
}, To = $({ name: "NButtonIcon" }), Nt = /* @__PURE__ */ $({
  ...To,
  props: {
    size: { default: "middle" },
    variant: { default: "fill" },
    color: { default: "green" },
    loading: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, r = E(() => [
      xo,
      _o[t.size],
      Ao[t.variant],
      t.variant === "fill" && Eo[t.color],
      t.variant === "flat" && Co[t.color],
      t.variant === "plain" && $o[t.color],
      t.variant === "outline" && So[t.color],
      {
        "!rounded-full": t.size === "mini"
      }
    ]);
    return (a, n) => (x(), I("button", {
      class: k(r.value)
    }, [
      a.loading ? (x(), P(f(ke), {
        key: 0,
        size: 10,
        class: "mx-auto"
      })) : R(a.$slots, "default", { key: 1 })
    ], 2));
  }
});
Nt.install = (e) => {
  e.component(Nt.name, Nt);
};
J.install = (e) => {
  e.component(J.name, J);
};
const Oo = $({ name: "NHeading" }), Rt = /* @__PURE__ */ $({
  ...Oo,
  props: {
    level: { default: 1 }
  },
  setup(e) {
    const t = e;
    return (r, a) => (x(), P(f(J), {
      tag: `h${t.level}`,
      variant: `h${t.level}`,
      weight: "bold"
    }, {
      default: V(() => [
        R(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["tag", "variant"]));
  }
});
Rt.install = (e) => {
  e.component(Rt.name, Rt);
};
const Bo = $({ name: "NTransitionFade" }), Hr = (e, t) => {
  const r = e.__vccOpts || e;
  for (const [a, n] of t)
    r[a] = n;
  return r;
};
function ko(e, t, r, a, n, o) {
  return x(), P(Pr, {
    "enter-active-class": "transition-all ease-in duration-100",
    "leave-active-class": "transition-all ease-out duration-100",
    "enter-from-class": "opacity-0",
    "enter-to-class": "opacity-100",
    "leave-from-class": "opacity-100",
    "leave-to-class": "opacity-0"
  }, {
    default: V(() => [
      R(e.$slots, "default")
    ]),
    _: 3
  });
}
const cr = /* @__PURE__ */ Hr(Bo, [["render", ko]]), Lo = { class: "mb-2" }, Io = ["htmlFor"], Do = $({ name: "NField" }), fr = /* @__PURE__ */ $({
  ...Do,
  props: {
    showError: { type: Boolean, default: !0 },
    error: { default: "" },
    label: { default: "" },
    labelPosition: { default: "top" },
    required: { type: Boolean, default: !1 },
    requiredSign: { type: Boolean, default: !0 }
  },
  setup(e) {
    const t = E(() => Te("input-"));
    return (r, a) => (x(), I("div", Lo, [
      L("div", {
        class: k({ flex: r.labelPosition === "inline" })
      }, [
        r.label ? (x(), I("label", {
          key: 0,
          class: k([r.labelPosition === "top" ? "inline-block mb-2" : "pt-3"]),
          htmlFor: t.value
        }, [
          j(f(J), {
            weight: "medium",
            variant: "caption1"
          }, {
            default: V(() => [
              Q(ee(r.label), 1)
            ]),
            _: 1
          }),
          r.required && r.requiredSign ? (x(), P(f(J), {
            key: 0,
            class: "text-critical-primary ps-1"
          }, {
            default: V(() => [
              Q("*")
            ]),
            _: 1
          })) : z("", !0)
        ], 10, Io)) : z("", !0),
        L("div", {
          class: k(["relative w-full", { "ms-2": r.labelPosition === "inline" }])
        }, [
          R(r.$slots, "input", { fieldId: t.value }),
          r.showError ? (x(), P(f(cr), { key: 0 }, {
            default: V(() => [
              R(r.$slots, "error", {}, () => [
                r.error ? (x(), P(f(J), {
                  key: 0,
                  weight: "regular",
                  variant: "caption2",
                  tag: "p",
                  role: "alert",
                  class: "text-critical-primary mt-1"
                }, {
                  default: V(() => [
                    Q(ee(r.error), 1)
                  ]),
                  _: 1
                })) : z("", !0)
              ])
            ]),
            _: 3
          })) : z("", !0)
        ], 2)
      ], 2)
    ]));
  }
}), ce = {
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
}, fe = {
  type: [Number, String],
  default: 24
}, No = {
  name: "NegarArrowDownIcon",
  props: { size: fe },
  render: (e) => K(
    "svg",
    {
      width: e.size,
      height: e.size,
      innerHTML: '<path fill-rule="evenodd" d="M12.67 15.723c-.37.37-.97.37-1.34 0L6.277 10.67a.947.947 0 0 1 1.34-1.34L12 13.713l4.383-4.383a.947.947 0 0 1 1.34 1.34z" clip-rule="evenodd"></path>',
      fill: "currentColor",
      ...ce
    }
  )
}, Ro = {
  name: "NegarArrowLeftIcon",
  props: { size: fe },
  render: (e) => K(
    "svg",
    {
      width: e.size,
      height: e.size,
      innerHTML: '<path fill-rule="evenodd" d="M14.67 6.277c.37.37.37.97 0 1.34L10.287 12l4.383 4.383a.947.947 0 1 1-1.34 1.34L8.277 12.67a.947.947 0 0 1 0-1.34l5.053-5.053c.37-.37.97-.37 1.34 0" clip-rule="evenodd"></path>',
      fill: "currentColor",
      ...ce
    }
  )
}, Po = {
  name: "NegarArrowRightIcon",
  props: { size: fe },
  render: (e) => K(
    "svg",
    {
      width: e.size,
      height: e.size,
      innerHTML: '<path fill-rule="evenodd" d="M9.277 6.277c.37-.37.97-.37 1.34 0l5.053 5.053c.37.37.37.97 0 1.34l-5.053 5.053a.947.947 0 1 1-1.34-1.34L13.66 12 9.277 7.617a.947.947 0 0 1 0-1.34" clip-rule="evenodd"></path>',
      fill: "currentColor",
      ...ce
    }
  )
}, Wa = {
  name: "NegarCloseBoldIcon",
  props: { size: fe },
  render: (e) => K(
    "svg",
    {
      width: e.size,
      height: e.size,
      innerHTML: '<path fill-rule="evenodd" d="M12 2.25A9.75 9.75 0 0 0 2.25 12 9.75 9.75 0 0 0 12 21.75 9.75 9.75 0 0 0 21.75 12 9.75 9.75 0 0 0 12 2.25m3.36 6.39a.75.75 0 0 1 0 1.06l-2.3 2.3 2.3 2.3a.75.75 0 0 1-1.06 1.06l-2.3-2.3-2.3 2.3a.75.75 0 0 1-1.06-1.06l2.3-2.3-2.3-2.3A.75.75 0 0 1 9.7 8.64l2.3 2.3 2.3-2.3a.75.75 0 0 1 1.06 0" clip-rule="evenodd"></path>',
      fill: "currentColor",
      ...ce
    }
  )
}, Mo = {
  name: "NegarCloseLightIcon",
  props: { size: fe },
  render: (e) => K(
    "svg",
    {
      width: e.size,
      height: e.size,
      innerHTML: '<path fill-rule="evenodd" d="M15.36 8.64a.75.75 0 0 1 0 1.06L9.7 15.36a.75.75 0 0 1-1.06-1.06l5.66-5.66a.75.75 0 0 1 1.06 0" clip-rule="evenodd"></path><path fill-rule="evenodd" d="M8.64 8.64a.75.75 0 0 1 1.06 0l5.66 5.66a.75.75 0 0 1-1.06 1.06L8.64 9.7a.75.75 0 0 1 0-1.06" clip-rule="evenodd"></path><path fill-rule="evenodd" d="M12 3.75A8.25 8.25 0 0 0 3.75 12 8.25 8.25 0 0 0 12 20.25 8.25 8.25 0 0 0 20.25 12 8.25 8.25 0 0 0 12 3.75M2.25 12A9.75 9.75 0 0 1 12 2.25 9.75 9.75 0 0 1 21.75 12 9.75 9.75 0 0 1 12 21.75 9.75 9.75 0 0 1 2.25 12" clip-rule="evenodd"></path>',
      fill: "currentColor",
      ...ce
    }
  )
}, ja = {
  name: "NegarCloseIcon",
  props: { size: fe },
  render: (e) => K(
    "svg",
    {
      width: e.size,
      height: e.size,
      innerHTML: '<path fill-rule="evenodd" d="M7.47 7.47a.75.75 0 0 1 1.06 0l8 8a.75.75 0 1 1-1.06 1.06l-8-8a.75.75 0 0 1 0-1.06" clip-rule="evenodd"></path><path fill-rule="evenodd" d="M16.53 7.47a.75.75 0 0 1 0 1.06l-8 8a.75.75 0 0 1-1.06-1.06l8-8a.75.75 0 0 1 1.06 0" clip-rule="evenodd"></path>',
      fill: "currentColor",
      ...ce
    }
  )
}, Ua = {
  name: "NegarErrorLightIcon",
  props: { size: fe },
  render: (e) => K(
    "svg",
    {
      width: e.size,
      height: e.size,
      innerHTML: '<path d="M12 13.9c-.4 0-.8-.3-.8-.8V9.4c0-.4.3-.8.8-.8s.8.3.8.8v3.7c0 .4-.4.8-.8.8m0 1.5c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1"></path><path d="M19.7 21.8H4.3c-1.1 0-2.1-.6-2.7-1.5-.6-1-.6-2.1 0-3.1L9.3 3.8c.6-1 1.6-1.6 2.7-1.6s2.1.6 2.7 1.6l7.7 13.4c.6 1 .5 2.1 0 3.1-.6.9-1.6 1.5-2.7 1.5M12 3.7c-.6 0-1.1.3-1.4.8L3 17.9c-.3.5-.3 1.1 0 1.6s.8.8 1.4.8h15.3c.6 0 1.1-.3 1.4-.8s.3-1.1 0-1.6L13.4 4.5c-.3-.5-.8-.8-1.4-.8"></path>',
      fill: "currentColor",
      ...ce
    }
  )
}, ma = {
  name: "NegarInfoWithBorderIcon",
  props: { size: fe },
  render: (e) => K(
    "svg",
    {
      width: e.size,
      height: e.size,
      innerHTML: '<path fill-rule="evenodd" d="M12 3.747a8.254 8.254 0 1 0 0 16.508 8.254 8.254 0 0 0 0-16.508m-9.754 8.254c0-5.387 4.367-9.754 9.754-9.754s9.754 4.367 9.754 9.754-4.367 9.754-9.754 9.754S2.246 17.388 2.246 12Zm8.003 3.501a.75.75 0 0 1 .75-.75h.41V12h-.4a.75.75 0 0 1 0-1.5h1.15a.75.75 0 0 1 .75.75v3.502h.4a.75.75 0 1 1 0 1.5H11a.75.75 0 0 1-.75-.75Zm1.6-8.256a1 1 0 0 1 1.001 1v.01a1 1 0 1 1-1-1.01Z" clip-rule="evenodd"></path>',
      fill: "currentColor",
      ...ce
    }
  )
}, zo = {
  name: "NegarSearchLightIcon",
  props: { size: fe },
  render: (e) => K(
    "svg",
    {
      width: e.size,
      height: e.size,
      innerHTML: '<path fill-rule="evenodd" d="M15.184 7.369a5.526 5.526 0 1 0-7.815 7.815 5.526 5.526 0 0 0 7.815-7.815m1.06-1.061a7.026 7.026 0 1 0-9.936 9.936 7.026 7.026 0 0 0 9.936-9.936" clip-rule="evenodd"></path><path fill-rule="evenodd" d="M15.18 15.18a.75.75 0 0 1 1.06 0l3.29 3.29a.75.75 0 0 1-1.06 1.06l-3.29-3.29a.75.75 0 0 1 0-1.06" clip-rule="evenodd"></path>',
      fill: "currentColor",
      ...ce
    }
  )
}, Vo = {
  name: "NegarSortDownIcon",
  props: { size: fe },
  render: (e) => K(
    "svg",
    {
      width: e.size,
      height: e.size,
      innerHTML: '<path d="M12.41 15.165a.5.5 0 0 1-.82 0L7.3 9.037a.5.5 0 0 1 .41-.787h8.58a.5.5 0 0 1 .41.787z"></path>',
      fill: "currentColor",
      ...ce
    }
  )
}, qo = {
  name: "NegarSortUpIcon",
  props: { size: fe },
  render: (e) => K(
    "svg",
    {
      width: e.size,
      height: e.size,
      innerHTML: '<path d="M12.41 8.835a.5.5 0 0 0-.82 0L7.3 14.963a.5.5 0 0 0 .41.787h8.58a.5.5 0 0 0 .41-.787z"></path>',
      fill: "currentColor",
      ...ce
    }
  )
}, st = {
  name: "NegarTickIcon",
  props: { size: fe },
  render: (e) => K(
    "svg",
    {
      width: e.size,
      height: e.size,
      innerHTML: '<path fill-rule="evenodd" d="M20.53 5.97a.75.75 0 0 1 0 1.06l-11 11a.75.75 0 0 1-1.06 0l-5-5a.75.75 0 1 1 1.06-1.06L9 16.44 19.47 5.97a.75.75 0 0 1 1.06 0" clip-rule="evenodd"></path>',
      fill: "currentColor",
      ...ce
    }
  )
}, Ho = {
  name: "NegarTikLightIcon",
  props: { size: fe },
  render: (e) => K(
    "svg",
    {
      width: e.size,
      height: e.size,
      innerHTML: '<g fill-rule="evenodd" clip-path="url(#negar-icon__a)" clip-rule="evenodd"><path d="M12 3.75A8.25 8.25 0 0 0 3.75 12 8.25 8.25 0 0 0 12 20.25 8.25 8.25 0 0 0 20.25 12 8.25 8.25 0 0 0 12 3.75M2.25 12A9.75 9.75 0 0 1 12 2.25 9.75 9.75 0 0 1 21.75 12 9.75 9.75 0 0 1 12 21.75 9.75 9.75 0 0 1 2.25 12"></path><path d="M16.53 9.47a.75.75 0 0 1 0 1.06l-5 5a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 1 1 1.06-1.06L11 13.94l4.47-4.47a.75.75 0 0 1 1.06 0"></path></g><defs><clipPath id="negar-icon__a"><path d="M0 0h24v24H0z"></path></clipPath></defs>',
      fill: "currentColor",
      ...ce
    }
  )
};
function Ke(e) {
  return Nn() ? (Rn(e), !0) : !1;
}
function H(e) {
  return typeof e == "function" ? e() : f(e);
}
const wt = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const Fo = Object.prototype.toString, Wo = (e) => Fo.call(e) === "[object Object]", se = () => {
}, Or = /* @__PURE__ */ jo();
function jo() {
  var e, t;
  return wt && ((e = window?.navigator) == null ? void 0 : e.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((t = window?.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window?.navigator.userAgent));
}
function Ya(e, t) {
  function r(...a) {
    return new Promise((n, o) => {
      Promise.resolve(e(() => t.apply(this, a), { fn: t, thisArg: this, args: a })).then(n).catch(o);
    });
  }
  return r;
}
function Uo(e, t = {}) {
  let r, a, n = se;
  const o = (l) => {
    clearTimeout(l), n(), n = se;
  };
  return (l) => {
    const s = H(e), d = H(t.maxWait);
    return r && o(r), s <= 0 || d !== void 0 && d <= 0 ? (a && (o(a), a = null), Promise.resolve(l())) : new Promise((u, c) => {
      n = t.rejectOnCancel ? c : u, d && !a && (a = setTimeout(() => {
        r && o(r), a = null, u(l());
      }, d)), r = setTimeout(() => {
        a && o(a), a = null, u(l());
      }, s);
    });
  };
}
function Yo(...e) {
  let t = 0, r, a = !0, n = se, o, i, l, s, d;
  !Ye(e[0]) && typeof e[0] == "object" ? { delay: i, trailing: l = !0, leading: s = !0, rejectOnCancel: d = !1 } = e[0] : [i, l = !0, s = !0, d = !1] = e;
  const u = () => {
    r && (clearTimeout(r), r = void 0, n(), n = se);
  };
  return (v) => {
    const p = H(i), b = Date.now() - t, m = () => o = v();
    return u(), p <= 0 ? (t = Date.now(), m()) : (b > p && (s || !a) ? (t = Date.now(), m()) : l && (o = new Promise((h, w) => {
      n = d ? w : h, r = setTimeout(() => {
        t = Date.now(), a = !0, h(m()), u();
      }, Math.max(0, p - b));
    })), !s && !r && (r = setTimeout(() => a = !0, p)), a = !1, o);
  };
}
function Xo(e) {
  return Pa();
}
function Go(...e) {
  if (e.length !== 1)
    return Pn(...e);
  const t = e[0];
  return typeof t == "function" ? Mn(Ra(() => ({ get: t, set: se }))) : T(t);
}
function Ko(e, t = 200, r = {}) {
  return Ya(
    Uo(t, r),
    e
  );
}
function Zo(e, t = 200, r = !1, a = !0, n = !1) {
  return Ya(
    Yo(t, r, a, n),
    e
  );
}
function Qo(e, t = {}) {
  if (!Ye(e))
    return ue(e);
  const r = Array.isArray(e.value) ? Array.from({ length: e.value.length }) : {};
  for (const a in e.value)
    r[a] = Ra(() => ({
      get() {
        return e.value[a];
      },
      set(n) {
        var o;
        if ((o = H(t.replaceRef)) != null ? o : !0)
          if (Array.isArray(e.value)) {
            const l = [...e.value];
            l[a] = n, e.value = l;
          } else {
            const l = { ...e.value, [a]: n };
            Object.setPrototypeOf(l, Object.getPrototypeOf(e.value)), e.value = l;
          }
        else
          e.value[a] = n;
      }
    }));
  return r;
}
function Fr(e, t = !0, r) {
  Xo() ? At(e, r) : t ? e() : Mr(e);
}
function Jo(e, t = 1e3, r = {}) {
  const {
    immediate: a = !0,
    immediateCallback: n = !1
  } = r;
  let o = null;
  const i = T(!1);
  function l() {
    o && (clearInterval(o), o = null);
  }
  function s() {
    i.value = !1, l();
  }
  function d() {
    const u = H(t);
    u <= 0 || (i.value = !0, n && e(), l(), o = setInterval(e, u));
  }
  if (a && wt && d(), Ye(t) || typeof t == "function") {
    const u = q(t, () => {
      i.value && wt && d();
    });
    Ke(u);
  }
  return Ke(s), {
    isActive: i,
    pause: s,
    resume: d
  };
}
function ve(e) {
  var t;
  const r = H(e);
  return (t = r?.$el) != null ? t : r;
}
const Ee = wt ? window : void 0;
function oe(...e) {
  let t, r, a, n;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([r, a, n] = e, t = Ee) : [t, r, a, n] = e, !t)
    return se;
  Array.isArray(r) || (r = [r]), Array.isArray(a) || (a = [a]);
  const o = [], i = () => {
    o.forEach((u) => u()), o.length = 0;
  }, l = (u, c, v, p) => (u.addEventListener(c, v, p), () => u.removeEventListener(c, v, p)), s = q(
    () => [ve(t), H(n)],
    ([u, c]) => {
      if (i(), !u)
        return;
      const v = Wo(c) ? { ...c } : c;
      o.push(
        ...r.flatMap((p) => a.map((b) => l(u, p, b, v)))
      );
    },
    { immediate: !0, flush: "post" }
  ), d = () => {
    s(), i();
  };
  return Ke(d), d;
}
let ha = !1;
function el(e, t, r = {}) {
  const { window: a = Ee, ignore: n = [], capture: o = !0, detectIframe: i = !1 } = r;
  if (!a)
    return se;
  Or && !ha && (ha = !0, Array.from(a.document.body.children).forEach((v) => v.addEventListener("click", se)), a.document.documentElement.addEventListener("click", se));
  let l = !0;
  const s = (v) => n.some((p) => {
    if (typeof p == "string")
      return Array.from(a.document.querySelectorAll(p)).some((b) => b === v.target || v.composedPath().includes(b));
    {
      const b = ve(p);
      return b && (v.target === b || v.composedPath().includes(b));
    }
  }), u = [
    oe(a, "click", (v) => {
      const p = ve(e);
      if (!(!p || p === v.target || v.composedPath().includes(p))) {
        if (v.detail === 0 && (l = !s(v)), !l) {
          l = !0;
          return;
        }
        t(v);
      }
    }, { passive: !0, capture: o }),
    oe(a, "pointerdown", (v) => {
      const p = ve(e);
      l = !s(v) && !!(p && !v.composedPath().includes(p));
    }, { passive: !0 }),
    i && oe(a, "blur", (v) => {
      setTimeout(() => {
        var p;
        const b = ve(e);
        ((p = a.document.activeElement) == null ? void 0 : p.tagName) === "IFRAME" && !b?.contains(a.document.activeElement) && t(v);
      }, 0);
    })
  ].filter(Boolean);
  return () => u.forEach((v) => v());
}
function tl(e) {
  return typeof e == "function" ? e : typeof e == "string" ? (t) => t.key === e : Array.isArray(e) ? (t) => e.includes(t.key) : () => !0;
}
function rl(...e) {
  let t, r, a = {};
  e.length === 3 ? (t = e[0], r = e[1], a = e[2]) : e.length === 2 ? typeof e[1] == "object" ? (t = !0, r = e[0], a = e[1]) : (t = e[0], r = e[1]) : (t = !0, r = e[0]);
  const {
    target: n = Ee,
    eventName: o = "keydown",
    passive: i = !1,
    dedupe: l = !1
  } = a, s = tl(t);
  return oe(n, o, (u) => {
    u.repeat && H(l) || s(u) && r(u);
  }, i);
}
function al() {
  const e = T(!1), t = Pa();
  return t && At(() => {
    e.value = !0;
  }, t), e;
}
function Xa(e) {
  const t = al();
  return E(() => (t.value, !!e()));
}
function nl(e, t = {}) {
  const { window: r = Ee } = t, a = Xa(() => r && "matchMedia" in r && typeof r.matchMedia == "function");
  let n;
  const o = T(!1), i = (d) => {
    o.value = d.matches;
  }, l = () => {
    n && ("removeEventListener" in n ? n.removeEventListener("change", i) : n.removeListener(i));
  }, s = zn(() => {
    a.value && (l(), n = r.matchMedia(H(e)), "addEventListener" in n ? n.addEventListener("change", i) : n.addListener(i), o.value = n.matches);
  });
  return Ke(() => {
    s(), l(), n = void 0;
  }), o;
}
function ol(e, t = {}) {
  var r, a;
  const {
    pointerTypes: n,
    preventDefault: o,
    stopPropagation: i,
    exact: l,
    onMove: s,
    onEnd: d,
    onStart: u,
    initialValue: c,
    axis: v = "both",
    draggingElement: p = Ee,
    containerElement: b,
    handle: m = e
  } = t, h = T(
    (r = H(c)) != null ? r : { x: 0, y: 0 }
  ), w = T(), A = (y) => n ? n.includes(y.pointerType) : !0, C = (y) => {
    H(o) && y.preventDefault(), H(i) && y.stopPropagation();
  }, g = (y) => {
    var B;
    if (y.button !== 0 || H(t.disabled) || !A(y) || H(l) && y.target !== H(e))
      return;
    const S = H(b), N = (B = S?.getBoundingClientRect) == null ? void 0 : B.call(S), M = H(e).getBoundingClientRect(), F = {
      x: y.clientX - (S ? M.left - N.left + S.scrollLeft : M.left),
      y: y.clientY - (S ? M.top - N.top + S.scrollTop : M.top)
    };
    u?.(F, y) !== !1 && (w.value = F, C(y));
  }, _ = (y) => {
    if (H(t.disabled) || !A(y) || !w.value)
      return;
    const B = H(b), S = H(e).getBoundingClientRect();
    let { x: N, y: M } = h.value;
    (v === "x" || v === "both") && (N = y.clientX - w.value.x, B && (N = Math.min(Math.max(0, N), B.scrollWidth - S.width))), (v === "y" || v === "both") && (M = y.clientY - w.value.y, B && (M = Math.min(Math.max(0, M), B.scrollHeight - S.height))), h.value = {
      x: N,
      y: M
    }, s?.(h.value, y), C(y);
  }, O = (y) => {
    H(t.disabled) || !A(y) || w.value && (w.value = void 0, d?.(h.value, y), C(y));
  };
  if (wt) {
    const y = { capture: (a = t.capture) != null ? a : !0 };
    oe(m, "pointerdown", g, y), oe(p, "pointermove", _, y), oe(p, "pointerup", O, y);
  }
  return {
    ...Qo(h),
    position: h,
    isDragging: E(() => !!w.value),
    style: E(
      () => `left:${h.value.x}px;top:${h.value.y}px;`
    )
  };
}
function ll(e, t, r = {}) {
  const { window: a = Ee, ...n } = r;
  let o;
  const i = Xa(() => a && "ResizeObserver" in a), l = () => {
    o && (o.disconnect(), o = void 0);
  }, s = E(() => Array.isArray(e) ? e.map((c) => ve(c)) : [ve(e)]), d = q(
    s,
    (c) => {
      if (l(), i.value && a) {
        o = new ResizeObserver(t);
        for (const v of c)
          v && o.observe(v, n);
      }
    },
    { immediate: !0, flush: "post" }
  ), u = () => {
    l(), d();
  };
  return Ke(u), {
    isSupported: i,
    stop: u
  };
}
function ar(e, t = { width: 0, height: 0 }, r = {}) {
  const { window: a = Ee, box: n = "content-box" } = r, o = E(() => {
    var c, v;
    return (v = (c = ve(e)) == null ? void 0 : c.namespaceURI) == null ? void 0 : v.includes("svg");
  }), i = T(t.width), l = T(t.height), { stop: s } = ll(
    e,
    ([c]) => {
      const v = n === "border-box" ? c.borderBoxSize : n === "content-box" ? c.contentBoxSize : c.devicePixelContentBoxSize;
      if (a && o.value) {
        const p = ve(e);
        if (p) {
          const b = p.getBoundingClientRect();
          i.value = b.width, l.value = b.height;
        }
      } else if (v) {
        const p = Array.isArray(v) ? v : [v];
        i.value = p.reduce((b, { inlineSize: m }) => b + m, 0), l.value = p.reduce((b, { blockSize: m }) => b + m, 0);
      } else
        i.value = c.contentRect.width, l.value = c.contentRect.height;
    },
    r
  );
  Fr(() => {
    const c = ve(e);
    c && (i.value = "offsetWidth" in c ? c.offsetWidth : t.width, l.value = "offsetHeight" in c ? c.offsetHeight : t.height);
  });
  const d = q(
    () => ve(e),
    (c) => {
      i.value = c ? t.width : 0, l.value = c ? t.height : 0;
    }
  );
  function u() {
    s(), d();
  }
  return {
    width: i,
    height: l,
    stop: u
  };
}
const ba = 1;
function il(e, t = {}) {
  const {
    throttle: r = 0,
    idle: a = 200,
    onStop: n = se,
    onScroll: o = se,
    offset: i = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    },
    eventListenerOptions: l = {
      capture: !1,
      passive: !0
    },
    behavior: s = "auto",
    window: d = Ee,
    onError: u = (y) => {
      console.error(y);
    }
  } = t, c = T(0), v = T(0), p = E({
    get() {
      return c.value;
    },
    set(y) {
      m(y, void 0);
    }
  }), b = E({
    get() {
      return v.value;
    },
    set(y) {
      m(void 0, y);
    }
  });
  function m(y, B) {
    var S, N, M, F;
    if (!d)
      return;
    const D = H(e);
    if (!D)
      return;
    (M = D instanceof Document ? d.document.body : D) == null || M.scrollTo({
      top: (S = H(B)) != null ? S : b.value,
      left: (N = H(y)) != null ? N : p.value,
      behavior: H(s)
    });
    const W = ((F = D?.document) == null ? void 0 : F.documentElement) || D?.documentElement || D;
    p != null && (c.value = W.scrollLeft), b != null && (v.value = W.scrollTop);
  }
  const h = T(!1), w = ze({
    left: !0,
    right: !1,
    top: !0,
    bottom: !1
  }), A = ze({
    left: !1,
    right: !1,
    top: !1,
    bottom: !1
  }), C = (y) => {
    h.value && (h.value = !1, A.left = !1, A.right = !1, A.top = !1, A.bottom = !1, n(y));
  }, g = Ko(C, r + a), _ = (y) => {
    var B;
    if (!d)
      return;
    const S = ((B = y?.document) == null ? void 0 : B.documentElement) || y?.documentElement || ve(y), { display: N, flexDirection: M } = getComputedStyle(S), F = S.scrollLeft;
    A.left = F < c.value, A.right = F > c.value;
    const D = Math.abs(F) <= (i.left || 0), W = Math.abs(F) + S.clientWidth >= S.scrollWidth - (i.right || 0) - ba;
    N === "flex" && M === "row-reverse" ? (w.left = W, w.right = D) : (w.left = D, w.right = W), c.value = F;
    let X = S.scrollTop;
    y === d.document && !X && (X = d.document.body.scrollTop), A.top = X < v.value, A.bottom = X > v.value;
    const Z = Math.abs(X) <= (i.top || 0), re = Math.abs(X) + S.clientHeight >= S.scrollHeight - (i.bottom || 0) - ba;
    N === "flex" && M === "column-reverse" ? (w.top = re, w.bottom = Z) : (w.top = Z, w.bottom = re), v.value = X;
  }, O = (y) => {
    var B;
    if (!d)
      return;
    const S = (B = y.target.documentElement) != null ? B : y.target;
    _(S), h.value = !0, g(y), o(y);
  };
  return oe(
    e,
    "scroll",
    r ? Zo(O, r, !0, !1) : O,
    l
  ), Fr(() => {
    try {
      const y = H(e);
      if (!y)
        return;
      _(y);
    } catch (y) {
      u(y);
    }
  }), oe(
    e,
    "scrollend",
    C,
    l
  ), {
    x: p,
    y: b,
    isScrolling: h,
    arrivedState: w,
    directions: A,
    measure() {
      const y = H(e);
      d && y && _(y);
    }
  };
}
function wr(e) {
  return typeof Window < "u" && e instanceof Window ? e.document.documentElement : typeof Document < "u" && e instanceof Document ? e.documentElement : e;
}
function Ga(e) {
  const t = window.getComputedStyle(e);
  if (t.overflowX === "scroll" || t.overflowY === "scroll" || t.overflowX === "auto" && e.clientWidth < e.scrollWidth || t.overflowY === "auto" && e.clientHeight < e.scrollHeight)
    return !0;
  {
    const r = e.parentNode;
    return !r || r.tagName === "BODY" ? !1 : Ga(r);
  }
}
function sl(e) {
  const t = e || window.event, r = t.target;
  return Ga(r) ? !1 : t.touches.length > 1 ? !0 : (t.preventDefault && t.preventDefault(), !1);
}
const xr = /* @__PURE__ */ new WeakMap();
function ul(e, t = !1) {
  const r = T(t);
  let a = null, n = "";
  q(Go(e), (l) => {
    const s = wr(H(l));
    if (s) {
      const d = s;
      if (xr.get(d) || xr.set(d, d.style.overflow), d.style.overflow !== "hidden" && (n = d.style.overflow), d.style.overflow === "hidden")
        return r.value = !0;
      if (r.value)
        return d.style.overflow = "hidden";
    }
  }, {
    immediate: !0
  });
  const o = () => {
    const l = wr(H(e));
    !l || r.value || (Or && (a = oe(
      l,
      "touchmove",
      (s) => {
        sl(s);
      },
      { passive: !1 }
    )), l.style.overflow = "hidden", r.value = !0);
  }, i = () => {
    const l = wr(H(e));
    !l || !r.value || (Or && a?.(), l.style.overflow = n, xr.delete(l), r.value = !1);
  };
  return Ke(i), E({
    get() {
      return r.value;
    },
    set(l) {
      l ? o() : i();
    }
  });
}
function Ka(e, t = {}) {
  const {
    threshold: r = 50,
    onSwipe: a,
    onSwipeEnd: n,
    onSwipeStart: o,
    passive: i = !0,
    window: l = Ee
  } = t, s = ze({ x: 0, y: 0 }), d = ze({ x: 0, y: 0 }), u = E(() => s.x - d.x), c = E(() => s.y - d.y), { max: v, abs: p } = Math, b = E(() => v(p(u.value), p(c.value)) >= r), m = T(!1), h = E(() => b.value ? p(u.value) > p(c.value) ? u.value > 0 ? "left" : "right" : c.value > 0 ? "up" : "down" : "none"), w = (S) => [S.touches[0].clientX, S.touches[0].clientY], A = (S, N) => {
    s.x = S, s.y = N;
  }, C = (S, N) => {
    d.x = S, d.y = N;
  };
  let g;
  const _ = dl(l?.document);
  i ? g = _ ? { passive: !0 } : { capture: !1 } : g = _ ? { passive: !1, capture: !0 } : { capture: !0 };
  const O = (S) => {
    m.value && n?.(S, h.value), m.value = !1;
  }, y = [
    oe(e, "touchstart", (S) => {
      if (S.touches.length !== 1)
        return;
      g.capture && !g.passive && S.preventDefault();
      const [N, M] = w(S);
      A(N, M), C(N, M), o?.(S);
    }, g),
    oe(e, "touchmove", (S) => {
      if (S.touches.length !== 1)
        return;
      const [N, M] = w(S);
      C(N, M), !m.value && b.value && (m.value = !0), m.value && a?.(S);
    }, g),
    oe(e, ["touchend", "touchcancel"], O, g)
  ];
  return {
    isPassiveEventSupported: _,
    isSwiping: m,
    direction: h,
    coordsStart: s,
    coordsEnd: d,
    lengthX: u,
    lengthY: c,
    stop: () => y.forEach((S) => S())
  };
}
function dl(e) {
  if (!e)
    return !1;
  let t = !1;
  const r = {
    get passive() {
      return t = !0, !1;
    }
  };
  return e.addEventListener("x", se, r), e.removeEventListener("x", se), t;
}
function cl(e, t) {
  const { containerStyle: r, wrapperProps: a, scrollTo: n, calculateRange: o, currentList: i, containerRef: l } = "itemHeight" in t ? vl(t, e) : pl(t, e);
  return {
    list: i,
    scrollTo: n,
    containerProps: {
      ref: l,
      onScroll: () => {
        o();
      },
      style: r
    },
    wrapperProps: a
  };
}
function Za(e) {
  const t = T(null), r = ar(t), a = T([]), n = Na(e);
  return { state: T({ start: 0, end: 10 }), source: n, currentList: a, size: r, containerRef: t };
}
function Qa(e, t, r) {
  return (a) => {
    if (typeof r == "number")
      return Math.ceil(a / r);
    const { start: n = 0 } = e.value;
    let o = 0, i = 0;
    for (let l = n; l < t.value.length; l++) {
      const s = r(l);
      if (o += s, i = l, o > a)
        break;
    }
    return i - n;
  };
}
function Ja(e, t) {
  return (r) => {
    if (typeof t == "number")
      return Math.floor(r / t) + 1;
    let a = 0, n = 0;
    for (let o = 0; o < e.value.length; o++) {
      const i = t(o);
      if (a += i, a >= r) {
        n = o;
        break;
      }
    }
    return n + 1;
  };
}
function en(e, t, r, a, { containerRef: n, state: o, currentList: i, source: l }) {
  return () => {
    const s = n.value;
    if (s) {
      const d = r(e === "vertical" ? s.scrollTop : s.scrollLeft), u = a(e === "vertical" ? s.clientHeight : s.clientWidth), c = d - t, v = d + u + t;
      o.value = {
        start: c < 0 ? 0 : c,
        end: v > l.value.length ? l.value.length : v
      }, i.value = l.value.slice(o.value.start, o.value.end).map((p, b) => ({
        data: p,
        index: b + o.value.start
      }));
    }
  };
}
function tn(e, t) {
  return (r) => typeof e == "number" ? r * e : t.value.slice(0, r).reduce((n, o, i) => n + e(i), 0);
}
function rn(e, t, r, a) {
  q([e.width, e.height, t, r], () => {
    a();
  });
}
function an(e, t) {
  return E(() => typeof e == "number" ? t.value.length * e : t.value.reduce((r, a, n) => r + e(n), 0));
}
const fl = {
  horizontal: "scrollLeft",
  vertical: "scrollTop"
};
function nn(e, t, r, a) {
  return (n) => {
    a.value && (a.value[fl[e]] = r(n), t());
  };
}
function pl(e, t) {
  const r = Za(t), { state: a, source: n, currentList: o, size: i, containerRef: l } = r, s = { overflowX: "auto" }, { itemWidth: d, overscan: u = 5 } = e, c = Qa(a, n, d), v = Ja(n, d), p = en("horizontal", u, v, c, r), b = tn(d, n), m = E(() => b(a.value.start)), h = an(d, n);
  rn(i, t, l, p);
  const w = nn("horizontal", p, b, l), A = E(() => ({
    style: {
      height: "100%",
      width: `${h.value - m.value}px`,
      marginLeft: `${m.value}px`,
      display: "flex"
    }
  }));
  return {
    scrollTo: w,
    calculateRange: p,
    wrapperProps: A,
    containerStyle: s,
    currentList: o,
    containerRef: l
  };
}
function vl(e, t) {
  const r = Za(t), { state: a, source: n, currentList: o, size: i, containerRef: l } = r, s = { overflowY: "auto" }, { itemHeight: d, overscan: u = 5 } = e, c = Qa(a, n, d), v = Ja(n, d), p = en("vertical", u, v, c, r), b = tn(d, n), m = E(() => b(a.value.start)), h = an(d, n);
  rn(i, t, l, p);
  const w = nn("vertical", p, b, l), A = E(() => ({
    style: {
      width: "100%",
      height: `${h.value - m.value}px`,
      marginTop: `${m.value}px`
    }
  }));
  return {
    calculateRange: p,
    scrollTo: w,
    containerStyle: s,
    wrapperProps: A,
    currentList: o,
    containerRef: l
  };
}
function Wr(e = {}) {
  const {
    window: t = Ee,
    initialWidth: r = Number.POSITIVE_INFINITY,
    initialHeight: a = Number.POSITIVE_INFINITY,
    listenOrientation: n = !0,
    includeScrollbar: o = !0
  } = e, i = T(r), l = T(a), s = () => {
    t && (o ? (i.value = t.innerWidth, l.value = t.innerHeight) : (i.value = t.document.documentElement.clientWidth, l.value = t.document.documentElement.clientHeight));
  };
  if (s(), Fr(s), oe("resize", s, { passive: !0 }), n) {
    const d = nl("(orientation: portrait)");
    q(d, () => s());
  }
  return { width: i, height: l };
}
function ml(e = "") {
  return e.replace(/[\u0660-\u0669]/g, function(t) {
    return String(t.charCodeAt(0) - 1632);
  }).replace(/[\u06f0-\u06f9]/g, function(t) {
    return String(t.charCodeAt(0) - 1776);
  });
}
const hl = "flex items-center leading-normal border border-neutral-primary-hover transition rounded-md p-3 bg-neutral-primary", bl = {
  normal: "shadow-medium "
}, gl = "bg-transparent appearance-none text-b w-full focus:outline-none", Ot = {
  disabled: "!bg-neutral-primary-disable !border-neutral-primary-disable text-neutral-tertiary opacity-100",
  invalid: "!bg-neutral-primary !border-critical-primary text-neutral-primary hover:bg-neutral-primary-hover hover:border-critical-primary-hover",
  normal: "!bg-neutral-primary text-neutral-primary !border-neutral-secondary hover:bg-neutral-primary-hover hover:border-neutral-secondary-hover active:bg-neutral-primary-press active:border-neutral-primary-press",
  selected: "!border-brand-primary"
}, yl = {
  small: "h-10",
  middle: "h-12"
};
var Br = /* @__PURE__ */ ((e) => (e.ArrowUp = "ArrowUp", e.ArrowDown = "ArrowDown", e))(Br || {});
const wl = ["id", "value", "disabled", "aria-invalid", "rows"], xl = ["id", "type", "value", "disabled", "aria-invalid"], _l = $({ name: "NInput", inheritAttrs: !1 }), ct = /* @__PURE__ */ $({
  ..._l,
  props: {
    modelValue: { default: "" },
    disabled: { type: Boolean, default: !1 },
    type: { default: "text" },
    label: { default: "" },
    labelPosition: { default: "top" },
    showError: { type: Boolean, default: !1 },
    error: { default: "" },
    required: { type: Boolean, default: !1 },
    requiredSign: { type: Boolean, default: !0 },
    clearable: { type: Boolean, default: !1 },
    rows: { default: 3 },
    inputClass: { default: "" },
    forceEnDigit: { type: Boolean, default: !0 },
    size: { default: "middle" },
    min: { default: -1 / 0 },
    max: { default: 1 / 0 },
    step: { default: 1 },
    changeValueOnMouseWheel: { type: Boolean, default: !0 }
  },
  emits: ["update:modelValue"],
  setup(e, { expose: t, emit: r }) {
    const a = e, n = r, o = Nr(), i = Vn(), l = T(), s = T(), d = E(() => !!a.error), u = T(!1), c = E(() => {
      const g = [gl, a.inputClass], _ = [
        hl,
        yl[a.size],
        {
          [bl.normal]: !a.disabled,
          [Ot.selected]: !a.disabled && !d.value && u.value,
          [Ot.invalid]: d.value,
          [Ot.normal]: !a.disabled && !d.value && !u.value
        }
      ];
      return {
        input: g,
        container: _
      };
    }), v = (g) => {
      if (a.forceEnDigit) {
        n("update:modelValue", ml(g.target.value));
        return;
      }
      n("update:modelValue", g.target.value);
    }, p = () => {
      n("update:modelValue", ""), l.value.focus();
    }, b = (g) => {
      u.value && (g.deltaY < 0 ? m() : h());
    }, m = () => {
      Number(a.modelValue) + a.step <= a.max && n("update:modelValue", Number(a.modelValue) + a.step);
    }, h = () => {
      Number(a.modelValue) - a.step >= a.min && n("update:modelValue", Number(a.modelValue) - a.step);
    }, w = ({ code: g }) => {
      const _ = {
        [Br.ArrowDown]: h,
        [Br.ArrowUp]: m
      };
      _[g] && _[g]();
    };
    el(s, () => u.value = !1), t({ hasFocus: u });
    const A = a.type === "tel" || a.type === "number", C = E(() => {
      const g = {
        keydown: (_) => {
          _.stopPropagation(), w(_);
        }
      };
      return a.changeValueOnMouseWheel && (g.wheel = (_) => {
        _.stopPropagation(), _.preventDefault(), b(_);
      }), g;
    });
    return (g, _) => (x(), P(f(fr), ne({
      showError: g.showError,
      error: g.error,
      required: g.required,
      requiredSign: g.requiredSign,
      label: g.label,
      labelPosition: g.labelPosition
    }, {
      class: f(i).class
    }), {
      input: V(({ fieldId: O }) => [
        L("div", ne({
          ref_key: "container",
          ref: s,
          class: [c.value.container, g.disabled ? f(Ot).disabled : ""]
        }, qn(f(A) ? C.value : {}, !0), {
          onClick: _[2] || (_[2] = (y) => l.value.focus())
        }), [
          f(o).prefix ? R(g.$slots, "prefix", { key: 0 }) : z("", !0),
          g.type === "textarea" ? (x(), I("textarea", ne({ key: 1 }, {
            ...f(i),
            class: c.value.input
          }, {
            id: O,
            ref_key: "inputRef",
            ref: l,
            value: g.modelValue,
            disabled: g.disabled,
            "aria-invalid": d.value,
            rows: g.rows,
            onInput: v,
            onFocus: _[0] || (_[0] = (y) => u.value = !0)
          }), null, 16, wl)) : (x(), I("input", ne({ key: 2 }, {
            ...f(i),
            class: c.value.input
          }, {
            id: O,
            ref_key: "inputRef",
            ref: l,
            type: g.type,
            value: g.modelValue,
            disabled: g.disabled,
            "aria-invalid": d.value,
            onInput: v,
            onFocus: _[1] || (_[1] = (y) => u.value = !0)
          }), null, 16, xl)),
          f(o).postfix || g.clearable || d.value ? (x(), I(he, { key: 3 }, [
            d.value && !f(o).postfix ? (x(), P(f(Ua), {
              key: 0,
              size: 24,
              class: "text-critical-primary"
            })) : g.clearable && g.modelValue ? (x(), P(f(Wa), {
              key: 1,
              class: "text-neutral-tertiary cursor-pointer",
              size: 24,
              onClick: Xe(p, ["stop"])
            })) : R(g.$slots, "postfix", { key: 2 })
          ], 64)) : z("", !0)
        ], 16),
        g.error ? z("", !0) : R(g.$slots, "default", { key: 0 })
      ]),
      error: V(() => [
        R(g.$slots, "error")
      ]),
      _: 3
    }, 16, ["class"]));
  }
});
ct.install = (e) => {
  e.component(ct.name, ct);
};
const Al = /* @__PURE__ */ L("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1), El = /* @__PURE__ */ L("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1), Sl = [
  Al,
  El
], Cl = $({ name: "NLoading" }), ke = /* @__PURE__ */ $({
  ...Cl,
  props: {
    size: { default: 10 }
  },
  setup(e) {
    return (t, r) => (x(), I("svg", {
      class: "animate-spin",
      fill: "none",
      viewBox: "0 0 24 24",
      style: Ce({
        width: `${t.size * 2}px`,
        height: `${t.size * 2}px`
      })
    }, Sl, 4));
  }
});
ke.install = (e) => {
  e.component(ke.name, ke);
};
const $l = ["stroke"], Tl = ["stroke"], Ol = $({ name: "NProgress" }), ft = /* @__PURE__ */ $({
  ...Ol,
  props: {
    percentage: {},
    backgroundColorCode: {},
    progressColorCode: { default: "white" },
    size: { default: 10 }
  },
  setup(e) {
    const t = e, r = E(() => ({
      "stroke-dasharray": 100,
      "stroke-dashoffset": 100 - t.percentage
    }));
    return (a, n) => (x(), I("svg", {
      viewBox: "0 0 120 120",
      class: "transform -rotate-90",
      style: Ce({
        width: `${a.size * 2}px`,
        height: `${a.size * 2}px`
      })
    }, [
      L("circle", {
        cx: "60",
        cy: "60",
        r: "54",
        fill: "none",
        stroke: a.backgroundColorCode,
        "stroke-width": "12"
      }, null, 8, $l),
      L("circle", {
        cx: "60",
        cy: "60",
        r: "54",
        fill: "none",
        stroke: a.progressColorCode,
        "stroke-width": "12",
        pathLength: "100",
        style: Ce(r.value)
      }, null, 12, Tl)
    ], 4));
  }
});
ft.install = (e) => {
  e.component(ft.name, ft);
};
function ga(e = 200) {
  return new Promise((t) => {
    setTimeout(() => t(), e);
  });
}
const We = T(window.location.hash.split("#"));
function Bl() {
  return {
    hashStack: We,
    popHash: () => {
      const a = We.value.pop();
      return history.pushState(
        null,
        "",
        We.value.length === 1 ? " " : `#${We.value.at(-1)}`
      ), a;
    },
    pushHash: (a) => {
      We.value.push(a), history.pushState(null, "", `#${a}`);
    },
    getLastHash: () => We.value.at(-1)
  };
}
const on = Symbol("BottomSheetContext"), kl = "fixed w-full h-full top-0 left-0 z-190 transition-colors bg-neutral-quaternary duration-200 bg-opacity-70 flex justify-center items-end pointer-events-none", Ll = "fixed bg-neutral-primary border-neutral-tertiary text-neutral-primary bottom-0 left-0 right-0 bottom-0 mx-auto transform translate-y-full rounded-t-2xl shadow-2xl opacity-0", Il = /* @__PURE__ */ L("i", { class: "h-1 w-12 rounded bg-neutral-tertiary inline-flex" }, null, -1), Dl = [
  Il
], Nl = /* @__PURE__ */ $({
  __name: "NBottomSheetContainer",
  emits: ["update:visible"],
  setup(e, { emit: t }) {
    const r = Te("bottom-sheet-"), a = T(), n = T(), o = T(!1), i = T(!1), l = T(!1), s = T(!1), d = T(0), { height: u } = Wr(), { hashStack: c, popHash: v, pushHash: p, getLastHash: b } = Bl(), m = ye(on), h = t, w = ul(document.body), { y: A, isScrolling: C } = il(n), g = ze({
      isOpen: m.modelValue,
      translateY: "100%",
      height: m.height
    }), _ = E(() => u.value - m.height);
    q(
      c,
      () => {
        m.hashBased && (b() === r ? window.addEventListener("popstate", S) : window.removeEventListener("popstate", S));
      },
      {
        deep: !0
      }
    );
    const O = () => {
      m.closable && S();
    }, y = async () => {
      M(), await ga(300), Ie();
    }, B = () => {
      const U = v();
      U && U === r && m.closable && y();
    }, S = async () => {
      m.hashBased ? B() : m.closable && y();
    }, N = async () => {
      s.value = !0, m.hashBased && p(r), await ga(10), g.translateY = `${_.value}px`, i.value = !1, g.isOpen = !0, w.value = !0, document.body.classList.add("overscroll-none");
    }, M = () => {
      g.translateY = "100%", g.isOpen = !1, o.value = !1, w.value = !1, m.hashBased && window.removeEventListener("popstate", S), document.body.classList.remove("overscroll-none");
    }, F = () => {
      o.value = !0, g.translateY = 0, g.isOpen = !0, g.height = u.value, w.value = !0, document.body.classList.add("overscroll-none");
    }, D = E(() => a.value), { lengthY: W, direction: X, isSwiping: Z } = Ka(D, {
      threshold: 0,
      onSwipe() {
        const U = _.value - W.value;
        if (X.value === "up") {
          if (Math.max(U, 0) === 0 || o.value)
            return;
          m.modelValue && m.expandable ? (g.translateY = `${U}px`, g.height = m.height + Math.abs(W.value)) : g.translateY = `${Math.max(
            U,
            _.value
          )}px`;
        }
        X.value === "down" && (o.value && d.value > W.value && (A.value <= 0 || l.value) ? g.translateY = `${d.value - W.value}px` : o.value || (g.translateY = `${_.value + Math.abs(W.value)}px`));
      },
      onSwipeEnd() {
        d.value = 0;
        const U = X.value === "up", ae = X.value === "down";
        if (o.value)
          Math.abs(W.value) > m.closeSwipeThreshold ? (U && F(), ae && (!C.value || A.value <= 0) && m.closable && S()) : g.translateY = 0;
        else if (Math.abs(W.value) > m.closeSwipeThreshold) {
          if (U) {
            if (m.expandable)
              return F();
            N();
          }
          ae && m.closable && S();
        } else
          g.translateY = `${_.value}px`;
      }
    });
    q(A, (U, ae) => {
      Z.value && (d.value += U - ae);
    }), q(
      () => m.modelValue,
      (U) => {
        U ? N() : m.closable && M();
      },
      {
        immediate: !0
      }
    );
    const re = E(() => ({
      transform: `translateZ(0) translateY(${g.translateY})`,
      "touch-action": "none",
      "will-change": "transform"
    })), Ie = () => {
      h("update:visible", g.isOpen), g.isOpen ? m.afterOpen?.() : m.closable && (i.value = !0, m.afterClose?.(), s.value = !1);
    };
    return q(_, (U) => {
      g.isOpen && (g.translateY = `${U}px`);
    }), Rr(() => {
      m.hashBased && window.removeEventListener("popstate", S);
    }), (U, ae) => s.value ? (x(), I("div", {
      key: 0,
      class: k([
        f(kl),
        {
          "bg-black bg-opacity-40 !pointer-events-auto": g.isOpen
        }
      ]),
      onClick: Xe(O, ["self"])
    }, [
      L("div", {
        ref_key: "containerRef",
        ref: a,
        class: k(["h-full", [
          f(Ll),
          {
            "transition-transform duration-300 ease-in-out": !f(Z),
            "!opacity-100": !i.value
          }
        ]]),
        style: Ce(re.value),
        onTransitionend: Ie
      }, [
        L("div", {
          class: "cursor-move flex justify-center items-center h-8",
          onTouchstart: ae[0] || (ae[0] = (tt) => l.value = !0),
          onTouchend: ae[1] || (ae[1] = (tt) => l.value = !1)
        }, Dl, 32),
        L("div", {
          ref_key: "scrollContainerRef",
          ref: n,
          class: k(["overflow-auto h-[calc(100%-32px)]", { "overflow-hidden": g.translateY !== 0 }]),
          onClick: ae[2] || (ae[2] = Xe(() => {
          }, ["stop"]))
        }, [
          R(U.$slots, "default")
        ], 2)
      ], 38)
    ], 2)) : z("", !0);
  }
}), Rl = $({ name: "NBottomSheet" }), Pt = /* @__PURE__ */ $({
  ...Rl,
  props: {
    modelValue: { type: Boolean, default: !1 },
    height: { default: 320 },
    expandable: { type: Boolean, default: !1 },
    closeSwipeThreshold: { default: 50 },
    closableOverlay: { type: Boolean, default: !0 },
    closable: { type: Boolean, default: !0 },
    hashBased: { type: Boolean, default: !0 },
    afterOpen: { type: Function, default: () => {
    } },
    afterClose: { type: Function, default: () => {
    } }
  },
  emits: ["update:modelValue"],
  setup(e) {
    return Ae(on, e), (r, a) => (x(), P(zr, { to: "body" }, [
      j(Nl, {
        "onUpdate:visible": a[0] || (a[0] = (n) => r.$emit("update:modelValue", n))
      }, {
        default: V(() => [
          R(r.$slots, "default")
        ]),
        _: 3
      })
    ]));
  }
});
Pt.install = (e) => {
  e.component(Pt.name, Pt);
};
const Pl = "w-5 h-5 rounded-full flex-shrink-0", nt = {
  normal: "transition duration-150 ease-in-out border border-neutral-tertiary ring-brand-secondary-hover group-hover:ring group-hover:bg-brand-secondary-hover group-hover:border-brand-primary-hover",
  selected: "transition duration-150 ease-in border ring-inset ring-4 ring-primary bg-brand-primary border-neutral-tertiary group-hover:ring-brand-secondary-hover group-hover:bg-brand-primary-hover group-hover:border-brand-primary-hover",
  disabled: "border border-neutral-quaternary-disable",
  disabledSelected: "border ring-inset ring-4 ring-primary border-neutral-quaternary-disable bg-neutral-quaternary-disable",
  invalid: "border border-critical-primary"
}, Ml = {
  start: "self-start",
  end: "self-end",
  center: "self-center"
}, zl = "group cursor-pointer", Bt = {
  horizontal: "inline-flex items-center me-4",
  vertical: "flex mb-4 last:mb-0",
  normal: "text-neutral-secondary",
  disabled: "text-neutral-secondary-disable cursor-not-allowed",
  invalid: "text-critical-primary"
}, ln = Symbol("RadioContext");
function Vl(e, t) {
  const r = ye(ln), a = E({
    get() {
      return r?.modelValue.value ?? e.modelValue;
    },
    set(s) {
      r ? r.handleUpdate(s) : t("update:modelValue", s);
    }
  }), n = E(() => r?.flow.value || "horizontal"), o = E(() => a.value === e.value), i = E(
    () => e.disabled || r?.disabled.value
  ), l = E(() => i.value ? -1 : 0);
  return {
    flow: n,
    model: a,
    isSelected: o,
    isDisabled: i,
    tabIndex: l
  };
}
const ql = ["aria-checked", "aria-disabled", "tabindex"], Hl = ["value", "name", "disabled"], Fl = { class: "ms-3 w-full" }, Wl = $({ name: "NRadio" }), Mt = /* @__PURE__ */ $({
  ...Wl,
  props: {
    modelValue: { type: [String, Number, Boolean], default: "" },
    value: { type: [String, Number, Boolean] },
    name: { default: "" },
    label: { default: "" },
    disabled: { type: Boolean, default: !1 },
    error: { default: "" },
    align: { default: "center" }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const r = e, a = t, { model: n, isDisabled: o, isSelected: i, tabIndex: l, flow: s } = Vl(r, a), d = E(() => {
      const u = r.error && !o.value && !i.value, c = [
        Pl,
        Ml[r.align],
        {
          [nt.normal]: !o.value && !i.value,
          [nt.selected]: i.value && !o.value,
          [nt.disabled]: o.value,
          [nt.disabledSelected]: o.value && i.value,
          [nt.invalid]: u
        }
      ], v = [
        zl,
        Bt[s.value],
        {
          [Bt.normal]: !r.error && !o.value,
          [Bt.disabled]: o.value,
          [Bt.invalid]: u
        }
      ];
      return {
        customRadioInput: c,
        label: v
      };
    });
    return (u, c) => (x(), I("label", {
      class: k(d.value.label),
      "aria-checked": f(n) === u.value,
      "aria-disabled": u.disabled,
      tabindex: f(l),
      role: "radio"
    }, [
      L("span", {
        class: k(d.value.customRadioInput)
      }, null, 2),
      Vr(L("input", {
        "onUpdate:modelValue": c[0] || (c[0] = (v) => Ye(n) ? n.value = v : null),
        value: u.value,
        name: u.name,
        disabled: u.disabled,
        tabindex: "-1",
        "aria-hidden": "true",
        type: "radio",
        class: "appearance-none"
      }, null, 8, Hl), [
        [Hn, f(n)]
      ]),
      L("span", Fl, [
        R(u.$slots, "default", {}, () => [
          Q(ee(u.label || u.value), 1)
        ])
      ])
    ], 10, ql));
  }
});
Mt.install = (e) => {
  e.component(Mt.name, Mt);
};
const jl = $({ name: "NRadioGroup" }), zt = /* @__PURE__ */ $({
  ...jl,
  props: {
    modelValue: { type: [String, Number, Boolean], default: "" },
    flow: { default: "horizontal" },
    label: { default: "" },
    error: { default: "" },
    disabled: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    requiredSign: { type: Boolean, default: !0 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const r = e, a = t, n = (o) => a("update:modelValue", o);
    return Ae(ln, { ...ue(r), handleUpdate: n }), (o, i) => (x(), P(f(fr), ne({
      error: o.error,
      label: o.label,
      required: o.required,
      requiredSign: o.requiredSign,
      showError: o.required
    }, { role: "radiogroup" }), {
      input: V(() => [
        R(o.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
});
zt.install = (e) => {
  e.component(zt.name, zt);
};
const Ul = "self-center w-5 h-5 flex-shrink-0 flex rounded-md justify-center", ot = {
  normal: "transition duration-150 ease-in-out border border-neutral-quaternary ring-brand-secondary-hover group-hover:ring group-hover:border-brand-primary-hover group-hover:bg-brand-secondary-hover",
  selected: "transition duration-150 ease-in bg-brand-primary ring-brand-secondary-hover group-hover:ring group-hover:bg-brand-primary-hover",
  disabled: "border bg-neutral-tertiary-disable border-neutral-secondary",
  disabledSelected: "bg-neutral-tertiary border-neutral-tertiary-disable",
  invalid: "border border-critical-primary"
}, Yl = "flex self-center", _r = {
  normal: "invisible",
  selected: "visible text-neutral-quaternary",
  disabled: "visible text-neutral-quaternary-disable"
}, Xl = "group cursor-pointer", kt = {
  horizontal: "inline-flex items-center me-4",
  vertical: "flex mb-4 last:mb-0",
  normal: "text-neutral-secondary",
  disabled: "text-neutral-secondary-disable cursor-not-allowed",
  invalid: "text-critical-primary"
};
var jr = /* @__PURE__ */ ((e) => (e.Horizontal = "horizontal", e.Vertical = "vertical", e))(jr || {});
const sn = Symbol("CheckboxContext");
function Gl(e) {
  const t = ue(e), r = ye(sn, null), a = E(() => e.disabled || r?.disabled?.value), n = E(() => a.value ? -1 : 0), o = Pe();
  if (r)
    return {
      active: E(() => r.isActive(e.value)),
      disabled: a,
      tabIndex: n,
      flow: r.flow,
      isActive: r.isActive,
      onStateChange: o.on,
      toggle: r.toggle
    };
  {
    const i = ir(t.modelValue, e.value);
    return {
      active: i,
      disabled: a,
      tabIndex: n,
      toggle: () => {
        i.value = !i.value, o.trigger(i.value);
      },
      isActive: () => {
      },
      onStateChange: o.on
    };
  }
}
function Kl(e) {
  const t = ue(e), r = ir(e.modelValue, []), a = Pe();
  function n(l) {
    return r.value.includes(l);
  }
  function o(l) {
    const s = r.value.includes(l), d = r.value.indexOf(l);
    s ? r.value.splice(d, 1) : r.value.push(l), a.trigger(r.value);
  }
  const i = {
    isActive: n,
    toggle: o,
    onStateChange: a.on,
    flow: t.flow || jr.Vertical,
    disabled: t.disabled,
    active: t.active
  };
  return Ae(sn, i), i;
}
const Zl = ["aria-disabled", "tabindex"], Ql = ["value", "name", "disabled"], Jl = { class: "ms-3" }, ei = $({ name: "NCheckbox" }), pt = /* @__PURE__ */ $({
  ...ei,
  props: {
    modelValue: { default: !1 },
    value: { default: !1 },
    name: { default: "" },
    label: { default: "" },
    disabled: { type: Boolean, default: !1 },
    error: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const r = e, { disabled: a, active: n, tabIndex: o, flow: i, onStateChange: l, toggle: s } = Gl(r), d = t;
    l((c) => {
      d("update:modelValue", c);
    });
    const u = E(() => {
      const c = r.error && !a.value && !n.value, v = [
        Ul,
        {
          [ot.normal]: !a.value && !n.value,
          [ot.selected]: n.value && !a.value,
          [ot.disabledSelected]: n.value && a.value,
          [ot.disabled]: a.value,
          [ot.invalid]: c
        }
      ], p = [
        Yl,
        {
          [_r.normal]: !n.value,
          [_r.selected]: n.value,
          [_r.disabled]: n.value && a.value
        }
      ], b = [
        Xl,
        kt[i ? i.value : "horizontal"],
        {
          [kt.normal]: !r.error && !a.value,
          [kt.disabled]: a.value,
          [kt.invalid]: c
        }
      ];
      return {
        customCheckboxInput: v,
        checkmark: p,
        label: b
      };
    });
    return (c, v) => (x(), I("label", {
      class: k(u.value.label),
      "aria-disabled": f(a),
      tabindex: f(o),
      role: "checkbox"
    }, [
      L("span", {
        class: k(u.value.customCheckboxInput)
      }, [
        j(f(st), {
          class: k(u.value.checkmark),
          size: "18"
        }, null, 8, ["class"])
      ], 2),
      L("input", {
        value: c.value,
        name: c.name,
        disabled: f(a),
        tabindex: "-1",
        "aria-hidden": "true",
        type: "checkbox",
        class: "appearance-none",
        onInput: v[0] || (v[0] = (p) => f(s)(c.value))
      }, null, 40, Ql),
      L("span", Jl, [
        R(c.$slots, "default", {}, () => [
          Q(ee(c.label), 1)
        ])
      ])
    ], 10, Zl));
  }
});
pt.install = (e) => {
  e.component(pt.name, pt);
};
const ti = $({ name: "NCheckboxGroup" }), Vt = /* @__PURE__ */ $({
  ...ti,
  props: {
    modelValue: { default: void 0 },
    flow: { default: jr.Vertical },
    label: { default: "" },
    error: { default: "" },
    disabled: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    requiredSign: { type: Boolean, default: !0 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const r = e, a = t, { onStateChange: n } = Kl(r);
    return n((o) => {
      a("update:modelValue", o);
    }), (o, i) => (x(), P(f(fr), ne({
      error: o.error,
      label: o.label,
      required: o.required,
      requiredSign: o.requiredSign,
      showError: o.required
    }, { role: "checkboxgroup" }), {
      input: V(() => [
        R(o.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
});
Vt.install = (e) => {
  e.component(Vt.name, Vt);
};
const ri = $({ name: "NTransitionFadeBottom" });
function ai(e, t, r, a, n, o) {
  return x(), P(Pr, {
    "enter-active-class": "transform transition-all ease-in-out duration-150",
    "leave-active-class": "transform transition-all ease-out duration-150",
    "enter-from-class": "opacity-0 translate-y-1/2 scale-95",
    "enter-to-class": "opacity-100 translate-y-0 scale-100",
    "leave-from-class": "opacity-100 translate-y-0 scale-100",
    "leave-to-class": "opacity-0 translate-y-1/2 scale-95"
  }, {
    default: V(() => [
      R(e.$slots, "default")
    ]),
    _: 3
  });
}
const ni = /* @__PURE__ */ Hr(ri, [["render", ai]]);
var G = /* @__PURE__ */ ((e) => (e.Positive = "positive", e.Alert = "alert", e.Negative = "negative", e.Neutral = "neutral", e))(G || {}), ut = /* @__PURE__ */ ((e) => (e[e.First = 1] = "First", e[e.Second = 2] = "Second", e))(ut || {});
const Ur = Symbol("ToastContext");
function oi(e) {
  const t = ye(Ur), r = E(() => f(e));
  if (!t)
    throw new Error(
      "useToast must be used within a app with registered NToast plugin"
    );
  return {
    alert: (l) => {
      t.add({
        ...l,
        variant: G.Alert,
        position: r.value?.position,
        offset: r.value?.offset
      });
    },
    neutral: (l) => {
      t.add({
        ...l,
        variant: G.Neutral,
        position: r.value?.position,
        offset: r.value?.offset
      });
    },
    positive: (l) => {
      t.add({
        ...l,
        variant: G.Positive,
        position: r.value?.position,
        offset: r.value?.offset
      });
    },
    negative: (l) => {
      t.add({
        ...l,
        variant: G.Negative,
        position: r.value?.position,
        offset: r.value?.offset
      });
    },
    ...t
  };
}
const li = (e, t) => e.split(".").reduce((r, a) => r[a], t);
function pr() {
  return { t: (t, r) => {
    const a = li(t, qr.messages());
    return typeof a == "function" ? a(r) : a;
  } };
}
const ii = "flex items-start justify-between py-3 px-3 rounded-md shadow-mini border", si = {
  top: "relative transition-all transform -translate-y-[103vh] duration-150 ease-in-out flex justify-center",
  bottom: "relative transition-all transform translate-y-[20vh] duration-150 ease-in-out flex justify-center"
}, ya = {
  [G.Positive]: {
    normal: "bg-brand-secondary-disable border-brand-primary text-brand-primary",
    disabled: "bg-brand-secondary-disable border-brand-primary text-brand-primary"
  },
  [G.Negative]: {
    normal: "bg-critical-secondary border-critical-primary text-critical-secondary",
    disabled: "bg-critical-secondary border-critical-primary text-critical-secondary"
  },
  [G.Alert]: {
    normal: "bg-warning-secondary border-warning-primary text-warning-primary",
    disabled: "bg-warning-secondary-hover border-warning-primary text-warning-primary"
  },
  [G.Neutral]: {
    normal: "bg-neutral-primary border-neutral-quaternary text-neutral-primary",
    disabled: "bg-neutral-primary border-neutral-quaternary text-neutral-primary"
  }
}, ui = "cursor-pointer w-5 h-5 rounded-full overflow-hidden flex items-center justify-center", di = {
  [G.Positive]: "bg-brand-secondary-disable text-brand-primary",
  [G.Negative]: "bg-critical-secondary text-critical-primary",
  [G.Neutral]: "bg-neutral-secondary text-neutral-secondary",
  [G.Alert]: "bg-warning-secondary text-warning-primary"
}, ci = {
  [G.Positive]: "#066137",
  [G.Negative]: "#BF4E58",
  [G.Alert]: "#7D5B07",
  [G.Neutral]: "#333333"
}, fi = {
  [G.Positive]: st,
  [G.Negative]: st,
  [G.Alert]: st,
  [G.Neutral]: st
}, wa = {
  top: {
    [ut.Second]: "scale-x-[0.90] !-translate-y-[100vh]",
    [ut.First]: "scale-x-[0.95] !-translate-y-[99vh]"
  },
  bottom: {
    [ut.Second]: "scale-x-[0.90] !-translate-y-4",
    [ut.First]: "scale-x-[0.95] !-translate-y-2"
  },
  hidden: "hidden"
}, pi = { class: "flex items-center" }, vi = { class: "flex items-center" }, mi = {
  key: 0,
  class: "flex items-center mx-2"
}, hi = $({ name: "NToast" }), bi = /* @__PURE__ */ $({
  ...hi,
  props: {
    message: { default: "" },
    duration: { default: 1e3 },
    variant: { default: G.Positive },
    loading: { type: Boolean, default: !1 },
    closable: { type: Boolean, default: !0 },
    index: {},
    id: {},
    icon: { default: void 0 },
    showIcon: { type: Boolean, default: !1 },
    enabled: { type: Boolean, default: !0 },
    depth: { default: 0 },
    queued: { type: Boolean, default: !1 },
    position: { default: "bottom" },
    offset: { default: 0 },
    removed: { type: Boolean, default: !1 }
  },
  emits: ["remove", "removeAll"],
  setup(e, { emit: t }) {
    const r = e, a = t, { t: n } = pr(), o = T(0), i = T(!1);
    let l = Date.now();
    const s = 3, d = E(
      () => o.value / r.duration * 100
    ), u = E(
      () => ci[r.variant]
    );
    let c = null;
    const v = async () => {
      cancelAnimationFrame(c), a("remove", r.id);
    }, p = async () => {
      cancelAnimationFrame(c), a("removeAll");
    }, b = async () => {
      if (i.value = !0, o.value = Date.now() - l, o.value >= r.duration) {
        await v();
        return;
      }
      !r.enabled && r.queued ? (cancelAnimationFrame(c), i.value = !1) : c = requestAnimationFrame(b);
    };
    c = requestAnimationFrame(b);
    const m = E(() => ({
      root: [
        ii,
        r.enabled || !r.queued ? ya[r.variant].normal : ya[r.variant].disabled
      ],
      close: [ui, di[r.variant]]
    })), h = () => Cr(r.message) ? r.message : K(
      J,
      {
        tag: "p",
        weight: "medium",
        variant: "caption1"
      },
      () => [r.message]
    ), w = E(() => fi[r.variant]), A = () => Cr(r.icon) ? r.icon : K(w.value), C = E(() => {
      const g = r.depth - r.index - 1;
      return g < s ? wa[r.position][g] : wa.hidden;
    });
    return q(
      () => r.enabled,
      (g) => {
        g && r.queued && (l = Date.now(), c = requestAnimationFrame(b));
      }
    ), (g, _) => (x(), I("div", {
      class: k([
        f(si)[g.position],
        {
          "!translate-y-0": i.value && g.position === "bottom",
          "!-translate-y-[98vh]": i.value && g.position === "top",
          "translate-x-[100vw] duration-[400ms]": g.removed
        },
        g.queued ? C.value : ""
      ]),
      style: Ce({ [g.position]: `${g.offset}px` })
    }, [
      L("div", {
        class: k([
          m.value.root,
          {
            "absolute w-full lg:w-max lg:min-w-[320px] lg:max-w-lg": g.queued,
            "bottom-0": g.position === "bottom" && g.queued
          }
        ])
      }, [
        L("div", pi, [
          g.showIcon ? (x(), P(A, {
            key: 0,
            class: "me-1"
          })) : z("", !0),
          j(h)
        ]),
        L("div", vi, [
          g.closable ? (x(), I("div", mi, [
            g.depth > 1 ? (x(), P(f(J), {
              key: 0,
              class: "text-neutral-secondary cursor-pointer whitespace-nowrap underline me-2",
              variant: "overline",
              weight: "medium",
              onClick: p
            }, {
              default: V(() => [
                Q(ee(f(n)("toast.removeAll")), 1)
              ]),
              _: 1
            })) : z("", !0),
            L("div", {
              class: k(m.value.close),
              onClick: v
            }, [
              j(f(ja))
            ], 2)
          ])) : z("", !0),
          g.loading ? (x(), P(f(ft), {
            key: 1,
            percentage: d.value,
            "background-color-code": u.value
          }, null, 8, ["percentage", "background-color-code"])) : z("", !0)
        ])
      ], 2)
    ], 6));
  }
}), gi = $({ name: "NToast" }), yi = /* @__PURE__ */ $({
  ...gi,
  props: {
    offset: { default: 0 },
    queued: { type: Boolean, default: !1 },
    position: { default: "bottom" }
  },
  setup(e) {
    const t = e, { toasts: r, remove: a, removeAll: n } = oi({ position: t.position });
    return (o, i) => (x(), I("div", {
      class: k(["fixed z-200 w-full px-4 bottom-0 left-1/2 -translate-x-1/2", { "space-y-2": !o.queued }])
    }, [
      (x(!0), I(he, null, Ge(f(r), (l, s) => (x(), P(bi, ne({ ref_for: !0 }, l, {
        key: l.id,
        index: s,
        depth: f(r).length,
        queued: o.queued,
        position: l.position ?? o.position,
        offset: l.offset ?? o.offset,
        enabled: s === f(r).length - 1,
        removed: l.removed,
        onRemove: f(a),
        onRemoveAll: f(n)
      }), null, 16, ["index", "depth", "queued", "position", "offset", "enabled", "removed", "onRemove", "onRemoveAll"]))), 128))
    ], 2));
  }
});
function xa(e = 200) {
  return new Promise((t) => {
    setTimeout(t, e);
  });
}
const Re = T([]), kr = {
  toasts: Re,
  add: (e) => {
    const t = Te("toast-");
    Re.value.push({ ...e, id: t });
  },
  async removeAll() {
    Re.value.forEach((e) => e.removed = !0), await xa(400), Re.value.length = 0;
  },
  async remove(e) {
    const t = Re.value.findIndex((r) => r.id === e);
    t > -1 && (Re.value[t].removed = !0, await xa(400), Re.value.splice(t, 1));
  }
}, wi = (e) => {
  const t = document.createElement("div");
  document.body.appendChild(t);
  const r = Fn(yi, {
    offset: e.offset,
    queued: e.queued,
    position: e.position
  });
  r.provide(Ur, kr), r.mount(t);
}, xi = (e, t) => {
  wi(t), e.provide(Ur, kr), e.config.globalProperties.$toasts = kr;
}, _i = { install: xi };
function un(e) {
  return e == null || e === "" || Array.isArray(e) && e.length === 0 || typeof e == "object" && Object.keys(e).length === 0;
}
const dn = Symbol("ListboxContext");
function cn() {
  const e = ye(dn);
  if (!e)
    throw new Error(
      "The useListboxContext hook must be used within <Listbox /> component."
    );
  return e;
}
function Ai(e, t) {
  const r = T(""), a = T(!1), n = T(-1), { modelValue: o, multiple: i, disabled: l, filterable: s } = ue(t), {
    state: d,
    isActive: u,
    onStateChange: c,
    toggle: v
  } = sr({
    initialState: t.modelValue,
    syncStateFrom: o,
    multiple: i
  }), p = Pe();
  q(r, (y) => {
    p.trigger(y);
  });
  function b(y) {
    const B = e.value.findIndex(
      ({ value: S }) => S === y.value
    );
    if (!(B < 0))
      return { ...e.value[B], index: B };
  }
  const m = E(() => Array.isArray(d.value) ? d.value?.map(b) : b(d.value));
  q(a, (y) => {
    if (y && t.modelValue) {
      const [B] = Array.isArray(t.modelValue) ? t.modelValue : [t.modelValue];
      n.value = e.value.findIndex(
        (S) => S.value === B?.value
      );
    }
  });
  function h() {
    l.value || (a.value = !0);
  }
  function w() {
    a.value = !1;
  }
  function A(y) {
    (i.value || y.value !== d.value?.value) && v(y), i.value || w();
  }
  function C(y) {
    n.value = Ve(y)({
      currentIndex: n.value,
      total: e.value.length,
      shouldIgnoreIndex(B) {
        return e.value[B].disabled;
      }
    }), Mr(() => {
      e.value[n.value]?.element?.scrollIntoView(!0);
    });
  }
  function g() {
    if (!a.value) {
      h();
      return;
    }
    if (n.value > -1) {
      A(e.value[n.value]);
      return;
    }
    w();
  }
  function _({ code: y }) {
    const B = {
      [Y.Escape]: w,
      [Y.Enter]: g,
      [Y.ArrowDown]: () => C(y),
      [Y.ArrowUp]: () => C(y)
    };
    if (B[y]) {
      B[y]();
      return;
    }
    h();
  }
  return q(
    () => d.value,
    () => {
      !Array.isArray(o?.value) && !un(o) && (r.value = o?.value?.label || o?.value?.value);
    },
    { immediate: !0 }
  ), Ae(dn, {
    focusedIndex: n,
    multiple: i,
    selectedOptions: d,
    isOptionSelected: u,
    filterable: s,
    query: r,
    handleSelect: A,
    handleClose: w,
    options: e
  }), {
    isOpen: a,
    query: r,
    selectedOptions: d,
    selectedOptionsProps: m,
    handleKeyDown: _,
    onStateChange: c,
    handleSelect: A,
    handleClose: w,
    onQueryChange: p.on
  };
}
const Ei = { class: "flex justify-center items-center border-t border-neutral-tertiary h-48" }, Si = { class: "text-neutral-tertiary" }, Ci = /* @__PURE__ */ $({
  __name: "EmptyOptions",
  setup(e) {
    const { t } = pr();
    return (r, a) => (x(), I("div", Ei, [
      L("div", Si, [
        j(f(zo), {
          size: 48,
          class: "mx-auto mb-2"
        }),
        j(f(J), { variant: "caption1" }, {
          default: V(() => [
            Q(ee(f(t)("listbox.no_matching_data")), 1)
          ]),
          _: 1
        })
      ])
    ]));
  }
}), $i = $({
  name: "NListboxOptions",
  inheritAttrs: !1
}), qt = /* @__PURE__ */ $({
  ...$i,
  props: {
    listboxLabelReference: {},
    elevation: {}
  },
  setup(e) {
    const { filterable: t, options: r, selectedOptions: a, multiple: n } = cn();
    return (o, i) => (x(), P(f(Ue), {
      "aria-labelledby": o.listboxLabelReference,
      "aria-activedescendant": f(a)?.id,
      as: "ul",
      elevation: o.elevation,
      role: "listbox",
      tabindex: "-1",
      multiselectable: f(n),
      class: k(["overflow-scroll w-full max-h-60 transform-gpu transition-all duration-300", { "mt-12": f(n) && f(a).length }]),
      border: ""
    }, {
      default: V(() => [
        f(t) && !f(r).length ? (x(), P(Ci, { key: 0 })) : z("", !0),
        R(o.$slots, "default")
      ]),
      _: 3
    }, 8, ["aria-labelledby", "aria-activedescendant", "elevation", "multiselectable", "class"]));
  }
});
qt.install = (e) => {
  e.component(qt.name, qt);
};
const Ti = "flex gap-x-2 overflow-x-auto py-3 relative z-200", Oi = { class: "relative w-full" }, Bi = $({ name: "NListbox", inheritAttrs: !1 }), Ht = /* @__PURE__ */ $({
  ...Bi,
  props: {
    modelValue: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    showError: { type: Boolean, default: !1 },
    error: { default: "" },
    label: { default: "" },
    placeholder: { default: "" },
    required: { type: Boolean, default: !1 },
    multiple: { type: Boolean, default: !1 },
    filterable: { type: Boolean, default: !1 },
    inputSize: { default: "middle" },
    dropdownElevation: { default: "large" }
  },
  emits: ["update:modelValue", "update:query"],
  setup(e, { expose: t, emit: r }) {
    const a = e, n = r, o = Te("listbox-"), { descendants: i } = dr(), {
      isOpen: l,
      query: s,
      selectedOptions: d,
      handleKeyDown: u,
      handleSelect: c,
      handleClose: v,
      onStateChange: p,
      onQueryChange: b
    } = Ai(i, a);
    p((C) => {
      n("update:modelValue", C);
    }), b((C) => {
      n("update:query", C);
    });
    const { t: m } = pr(), h = E(
      () => a.multiple && Array.isArray(d.value) && !!d.value?.length
    ), w = E(() => a.placeholder ? a.placeholder : m("listbox.select")), A = E(() => ({
      multiple: Ti
    }));
    return t({ handleClose: v }), (C, g) => (x(), I(he, null, [
      j(f(ht), {
        modelValue: f(l),
        "onUpdate:modelValue": g[1] || (g[1] = (_) => Ye(l) ? l.value = _ : null),
        disabled: C.disabled,
        hover: !1,
        placement: "bottom-start",
        "offset-y": "2",
        "same-width": ""
      }, {
        content: V(() => [
          j(f(cr), null, {
            default: V(() => [
              j(f(qt), {
                "listbox-label-reference": f(o),
                elevation: C.dropdownElevation
              }, {
                default: V(() => [
                  R(C.$slots, "default")
                ]),
                _: 3
              }, 8, ["listbox-label-reference", "elevation"])
            ]),
            _: 3
          })
        ]),
        default: V(() => [
          L("div", Oi, [
            j(f(ct), {
              id: f(o),
              modelValue: f(s),
              "onUpdate:modelValue": g[0] || (g[0] = (_) => Ye(s) ? s.value = _ : null),
              label: C.label,
              placeholder: w.value,
              "show-error": C.showError,
              error: C.error,
              required: C.required,
              disabled: C.disabled,
              "aria-expanded": f(l),
              "aria-labelledby": f(o),
              "aria-haspopup": "listbox",
              class: "!mb-0",
              readonly: !C.filterable,
              size: C.inputSize,
              onKeydown: Xe(f(u), ["stop"])
            }, {
              postfix: V(() => [
                j(f(No), {
                  size: 20,
                  class: k([
                    "transform transition flex-shrink-0 cursor-pointer",
                    { "rotate-180": f(l) }
                  ])
                }, null, 8, ["class"])
              ]),
              _: 1
            }, 8, ["id", "modelValue", "label", "placeholder", "show-error", "error", "required", "disabled", "aria-expanded", "aria-labelledby", "readonly", "size", "onKeydown"])
          ])
        ]),
        _: 3
      }, 8, ["modelValue", "disabled"]),
      h.value ? (x(), I("div", {
        key: 0,
        class: k(A.value.multiple)
      }, [
        R(C.$slots, "selections", { selection: f(d) }, () => [
          (x(!0), I(he, null, Ge(f(d), (_, O) => (x(), P(f(bt), {
            key: O,
            label: _.label,
            onClose: (y) => f(c)(_)
          }, null, 8, ["label", "onClose"]))), 128))
        ])
      ], 2)) : z("", !0)
    ], 64));
  }
});
Ht.install = (e) => {
  e.component(Ht.name, Ht);
};
function ki(e = "") {
  return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
const Li = "bg-neutral-primary text-neutral-primary items-center py-2 px-3 text-b active:bg-neutral-primary-press active:text-neutral-primary-press hover:bg-neutral-primary-hover hover:text-neutral-primary-hover hover:border-neutral-tertiary-hover flex items-center border-y-[0.5px] border-neutral-secondary", Ii = ["id", "aria-disabled", "aria-selected"], Di = $({ name: "NListboxOption" }), Ft = /* @__PURE__ */ $({
  ...Di,
  props: {
    value: {},
    disabled: { type: Boolean, default: !1 },
    label: { default: "" }
  },
  setup(e) {
    const t = e, {
      handleSelect: r,
      isOptionSelected: a,
      query: n,
      multiple: o,
      focusedIndex: i,
      filterable: l
    } = cn(), { ref: s, index: d, id: u } = ur({
      ...t,
      idPrefix: "listbox-option-"
    }), c = E(() => a(t.value)), v = E(() => {
      if (l.value) {
        const b = new RegExp(ki(n.value), "i");
        return b.test(t.label) || b.test(String(t.value));
      }
      return !0;
    }), p = (b) => {
      if (t.disabled) {
        b.preventDefault();
        return;
      }
      r({ value: t.value, label: t.label });
    };
    return (b, m) => v.value ? (x(), I("li", {
      key: 0,
      id: f(u),
      ref_key: "ref",
      ref: s,
      "aria-disabled": b.disabled,
      "aria-selected": c.value,
      role: "option",
      class: k([
        f(Li),
        {
          "!text-neutral-primary-press !border-neutral-tertiary-disable !bg-neutral-primary-hover": f(d) === f(i),
          "opacity-80 cursor-not-allowed !bg-neutral-primary-disable !text-neutral-secondary !border-neutral-tertiary-disable": b.disabled,
          "cursor-pointer": !b.disabled,
          "!bg-neutral-primary-press !text-neutral-primary-press": c.value
        }
      ]),
      onClick: p
    }, [
      f(o) ? (x(), P(f(pt), {
        key: 0,
        modelValue: c.value,
        "onUpdate:modelValue": m[0] || (m[0] = (h) => c.value = h),
        class: "me-2.5 pointer-events-none",
        disabled: b.disabled
      }, null, 8, ["modelValue", "disabled"])) : z("", !0),
      R(b.$slots, "default")
    ], 10, Ii)) : z("", !0);
  }
});
Ft.install = (e) => {
  e.component(Ft.name, Ft);
};
function Ni(e, t) {
  const r = fn(e);
  return Wn(r, t, !0);
}
function _a(e) {
  return Ri(e) ? fn(e.children) : e;
}
function fn(e) {
  return Array.isArray(e) ? _a(e[0]) : _a(e);
}
const Ri = (e) => e.type === he, Pi = "before:absolute before:w-3 before:h-3 before:rotate-45", Mi = {
  right: "-left-1.5",
  left: "right-1.5",
  bottom: "-top-1.5",
  top: "bottom-1.5"
};
function zi({
  arrow: e,
  arrowClass: t,
  arrowRightClass: r,
  arrowLeftClass: a,
  arrowTopClass: n,
  arrowBottomClass: o,
  disabled: i,
  isOpen: l,
  arrowPlacement: s,
  wrapperClass: d,
  $slots: u
}) {
  const c = s.split("-")[0], v = {
    right: r,
    left: a,
    top: n,
    bottom: o
  }[c], p = Mi[c];
  return Vr(
    K(
      "div",
      {
        ref: "popperElement",
        class: `z-180 ${d}`
      },
      [
        l ? u.content({ isOpen: l }) : null,
        e ? K(
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          "div",
          {
            class: `${Pi} ${p} ${v} ${t}`,
            "data-popper-arrow": ""
          },
          null
        ) : null
      ]
    ),
    [[Ma, !i && l]]
  );
}
const Vi = [
  "auto",
  "auto-start",
  "auto-end",
  "top",
  "top-start",
  "top-end",
  "bottom",
  "bottom-start",
  "bottom-end",
  "right",
  "right-start",
  "right-end",
  "left",
  "left-start",
  "left-end"
];
var le = "top", be = "bottom", ge = "right", ie = "left", Yr = "auto", Et = [le, be, ge, ie], Ze = "start", xt = "end", qi = "clippingParents", pn = "viewport", lt = "popper", Hi = "reference", Aa = /* @__PURE__ */ Et.reduce(function(e, t) {
  return e.concat([t + "-" + Ze, t + "-" + xt]);
}, []), vn = /* @__PURE__ */ [].concat(Et, [Yr]).reduce(function(e, t) {
  return e.concat([t, t + "-" + Ze, t + "-" + xt]);
}, []), Fi = "beforeRead", Wi = "read", ji = "afterRead", Ui = "beforeMain", Yi = "main", Xi = "afterMain", Gi = "beforeWrite", Ki = "write", Zi = "afterWrite", Qi = [Fi, Wi, ji, Ui, Yi, Xi, Gi, Ki, Zi];
function _e(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function de(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function qe(e) {
  var t = de(e).Element;
  return e instanceof t || e instanceof Element;
}
function me(e) {
  var t = de(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function Xr(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = de(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function Ji(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(r) {
    var a = t.styles[r] || {}, n = t.attributes[r] || {}, o = t.elements[r];
    !me(o) || !_e(o) || (Object.assign(o.style, a), Object.keys(n).forEach(function(i) {
      var l = n[i];
      l === !1 ? o.removeAttribute(i) : o.setAttribute(i, l === !0 ? "" : l);
    }));
  });
}
function es(e) {
  var t = e.state, r = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, r.popper), t.styles = r, t.elements.arrow && Object.assign(t.elements.arrow.style, r.arrow), function() {
    Object.keys(t.elements).forEach(function(a) {
      var n = t.elements[a], o = t.attributes[a] || {}, i = Object.keys(t.styles.hasOwnProperty(a) ? t.styles[a] : r[a]), l = i.reduce(function(s, d) {
        return s[d] = "", s;
      }, {});
      !me(n) || !_e(n) || (Object.assign(n.style, l), Object.keys(o).forEach(function(s) {
        n.removeAttribute(s);
      }));
    });
  };
}
const ts = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: Ji,
  effect: es,
  requires: ["computeStyles"]
};
function we(e) {
  return e.split("-")[0];
}
var Me = Math.max, nr = Math.min, Qe = Math.round;
function Lr() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function mn() {
  return !/^((?!chrome|android).)*safari/i.test(Lr());
}
function Je(e, t, r) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  var a = e.getBoundingClientRect(), n = 1, o = 1;
  t && me(e) && (n = e.offsetWidth > 0 && Qe(a.width) / e.offsetWidth || 1, o = e.offsetHeight > 0 && Qe(a.height) / e.offsetHeight || 1);
  var i = qe(e) ? de(e) : window, l = i.visualViewport, s = !mn() && r, d = (a.left + (s && l ? l.offsetLeft : 0)) / n, u = (a.top + (s && l ? l.offsetTop : 0)) / o, c = a.width / n, v = a.height / o;
  return {
    width: c,
    height: v,
    top: u,
    right: d + c,
    bottom: u + v,
    left: d,
    x: d,
    y: u
  };
}
function Gr(e) {
  var t = Je(e), r = e.offsetWidth, a = e.offsetHeight;
  return Math.abs(t.width - r) <= 1 && (r = t.width), Math.abs(t.height - a) <= 1 && (a = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: r,
    height: a
  };
}
function hn(e, t) {
  var r = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (r && Xr(r)) {
    var a = t;
    do {
      if (a && e.isSameNode(a))
        return !0;
      a = a.parentNode || a.host;
    } while (a);
  }
  return !1;
}
function $e(e) {
  return de(e).getComputedStyle(e);
}
function rs(e) {
  return ["table", "td", "th"].indexOf(_e(e)) >= 0;
}
function Le(e) {
  return ((qe(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function vr(e) {
  return _e(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (Xr(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Le(e)
  );
}
function Ea(e) {
  return !me(e) || // https://github.com/popperjs/popper-core/issues/837
  $e(e).position === "fixed" ? null : e.offsetParent;
}
function as(e) {
  var t = /firefox/i.test(Lr()), r = /Trident/i.test(Lr());
  if (r && me(e)) {
    var a = $e(e);
    if (a.position === "fixed")
      return null;
  }
  var n = vr(e);
  for (Xr(n) && (n = n.host); me(n) && ["html", "body"].indexOf(_e(n)) < 0; ) {
    var o = $e(n);
    if (o.transform !== "none" || o.perspective !== "none" || o.contain === "paint" || ["transform", "perspective"].indexOf(o.willChange) !== -1 || t && o.willChange === "filter" || t && o.filter && o.filter !== "none")
      return n;
    n = n.parentNode;
  }
  return null;
}
function St(e) {
  for (var t = de(e), r = Ea(e); r && rs(r) && $e(r).position === "static"; )
    r = Ea(r);
  return r && (_e(r) === "html" || _e(r) === "body" && $e(r).position === "static") ? t : r || as(e) || t;
}
function Kr(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function vt(e, t, r) {
  return Me(e, nr(t, r));
}
function ns(e, t, r) {
  var a = vt(e, t, r);
  return a > r ? r : a;
}
function bn() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function gn(e) {
  return Object.assign({}, bn(), e);
}
function yn(e, t) {
  return t.reduce(function(r, a) {
    return r[a] = e, r;
  }, {});
}
var os = function(t, r) {
  return t = typeof t == "function" ? t(Object.assign({}, r.rects, {
    placement: r.placement
  })) : t, gn(typeof t != "number" ? t : yn(t, Et));
};
function ls(e) {
  var t, r = e.state, a = e.name, n = e.options, o = r.elements.arrow, i = r.modifiersData.popperOffsets, l = we(r.placement), s = Kr(l), d = [ie, ge].indexOf(l) >= 0, u = d ? "height" : "width";
  if (!(!o || !i)) {
    var c = os(n.padding, r), v = Gr(o), p = s === "y" ? le : ie, b = s === "y" ? be : ge, m = r.rects.reference[u] + r.rects.reference[s] - i[s] - r.rects.popper[u], h = i[s] - r.rects.reference[s], w = St(o), A = w ? s === "y" ? w.clientHeight || 0 : w.clientWidth || 0 : 0, C = m / 2 - h / 2, g = c[p], _ = A - v[u] - c[b], O = A / 2 - v[u] / 2 + C, y = vt(g, O, _), B = s;
    r.modifiersData[a] = (t = {}, t[B] = y, t.centerOffset = y - O, t);
  }
}
function is(e) {
  var t = e.state, r = e.options, a = r.element, n = a === void 0 ? "[data-popper-arrow]" : a;
  n != null && (typeof n == "string" && (n = t.elements.popper.querySelector(n), !n) || hn(t.elements.popper, n) && (t.elements.arrow = n));
}
const ss = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: ls,
  effect: is,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function et(e) {
  return e.split("-")[1];
}
var us = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function ds(e, t) {
  var r = e.x, a = e.y, n = t.devicePixelRatio || 1;
  return {
    x: Qe(r * n) / n || 0,
    y: Qe(a * n) / n || 0
  };
}
function Sa(e) {
  var t, r = e.popper, a = e.popperRect, n = e.placement, o = e.variation, i = e.offsets, l = e.position, s = e.gpuAcceleration, d = e.adaptive, u = e.roundOffsets, c = e.isFixed, v = i.x, p = v === void 0 ? 0 : v, b = i.y, m = b === void 0 ? 0 : b, h = typeof u == "function" ? u({
    x: p,
    y: m
  }) : {
    x: p,
    y: m
  };
  p = h.x, m = h.y;
  var w = i.hasOwnProperty("x"), A = i.hasOwnProperty("y"), C = ie, g = le, _ = window;
  if (d) {
    var O = St(r), y = "clientHeight", B = "clientWidth";
    if (O === de(r) && (O = Le(r), $e(O).position !== "static" && l === "absolute" && (y = "scrollHeight", B = "scrollWidth")), O = O, n === le || (n === ie || n === ge) && o === xt) {
      g = be;
      var S = c && O === _ && _.visualViewport ? _.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        O[y]
      );
      m -= S - a.height, m *= s ? 1 : -1;
    }
    if (n === ie || (n === le || n === be) && o === xt) {
      C = ge;
      var N = c && O === _ && _.visualViewport ? _.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        O[B]
      );
      p -= N - a.width, p *= s ? 1 : -1;
    }
  }
  var M = Object.assign({
    position: l
  }, d && us), F = u === !0 ? ds({
    x: p,
    y: m
  }, de(r)) : {
    x: p,
    y: m
  };
  if (p = F.x, m = F.y, s) {
    var D;
    return Object.assign({}, M, (D = {}, D[g] = A ? "0" : "", D[C] = w ? "0" : "", D.transform = (_.devicePixelRatio || 1) <= 1 ? "translate(" + p + "px, " + m + "px)" : "translate3d(" + p + "px, " + m + "px, 0)", D));
  }
  return Object.assign({}, M, (t = {}, t[g] = A ? m + "px" : "", t[C] = w ? p + "px" : "", t.transform = "", t));
}
function cs(e) {
  var t = e.state, r = e.options, a = r.gpuAcceleration, n = a === void 0 ? !0 : a, o = r.adaptive, i = o === void 0 ? !0 : o, l = r.roundOffsets, s = l === void 0 ? !0 : l, d = {
    placement: we(t.placement),
    variation: et(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: n,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, Sa(Object.assign({}, d, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: i,
    roundOffsets: s
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, Sa(Object.assign({}, d, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: s
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const fs = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: cs,
  data: {}
};
var Lt = {
  passive: !0
};
function ps(e) {
  var t = e.state, r = e.instance, a = e.options, n = a.scroll, o = n === void 0 ? !0 : n, i = a.resize, l = i === void 0 ? !0 : i, s = de(t.elements.popper), d = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return o && d.forEach(function(u) {
    u.addEventListener("scroll", r.update, Lt);
  }), l && s.addEventListener("resize", r.update, Lt), function() {
    o && d.forEach(function(u) {
      u.removeEventListener("scroll", r.update, Lt);
    }), l && s.removeEventListener("resize", r.update, Lt);
  };
}
const vs = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: ps,
  data: {}
};
var ms = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Wt(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return ms[t];
  });
}
var hs = {
  start: "end",
  end: "start"
};
function Ca(e) {
  return e.replace(/start|end/g, function(t) {
    return hs[t];
  });
}
function Zr(e) {
  var t = de(e), r = t.pageXOffset, a = t.pageYOffset;
  return {
    scrollLeft: r,
    scrollTop: a
  };
}
function Qr(e) {
  return Je(Le(e)).left + Zr(e).scrollLeft;
}
function bs(e, t) {
  var r = de(e), a = Le(e), n = r.visualViewport, o = a.clientWidth, i = a.clientHeight, l = 0, s = 0;
  if (n) {
    o = n.width, i = n.height;
    var d = mn();
    (d || !d && t === "fixed") && (l = n.offsetLeft, s = n.offsetTop);
  }
  return {
    width: o,
    height: i,
    x: l + Qr(e),
    y: s
  };
}
function gs(e) {
  var t, r = Le(e), a = Zr(e), n = (t = e.ownerDocument) == null ? void 0 : t.body, o = Me(r.scrollWidth, r.clientWidth, n ? n.scrollWidth : 0, n ? n.clientWidth : 0), i = Me(r.scrollHeight, r.clientHeight, n ? n.scrollHeight : 0, n ? n.clientHeight : 0), l = -a.scrollLeft + Qr(e), s = -a.scrollTop;
  return $e(n || r).direction === "rtl" && (l += Me(r.clientWidth, n ? n.clientWidth : 0) - o), {
    width: o,
    height: i,
    x: l,
    y: s
  };
}
function Jr(e) {
  var t = $e(e), r = t.overflow, a = t.overflowX, n = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + n + a);
}
function wn(e) {
  return ["html", "body", "#document"].indexOf(_e(e)) >= 0 ? e.ownerDocument.body : me(e) && Jr(e) ? e : wn(vr(e));
}
function mt(e, t) {
  var r;
  t === void 0 && (t = []);
  var a = wn(e), n = a === ((r = e.ownerDocument) == null ? void 0 : r.body), o = de(a), i = n ? [o].concat(o.visualViewport || [], Jr(a) ? a : []) : a, l = t.concat(i);
  return n ? l : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    l.concat(mt(vr(i)))
  );
}
function Ir(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function ys(e, t) {
  var r = Je(e, !1, t === "fixed");
  return r.top = r.top + e.clientTop, r.left = r.left + e.clientLeft, r.bottom = r.top + e.clientHeight, r.right = r.left + e.clientWidth, r.width = e.clientWidth, r.height = e.clientHeight, r.x = r.left, r.y = r.top, r;
}
function $a(e, t, r) {
  return t === pn ? Ir(bs(e, r)) : qe(t) ? ys(t, r) : Ir(gs(Le(e)));
}
function ws(e) {
  var t = mt(vr(e)), r = ["absolute", "fixed"].indexOf($e(e).position) >= 0, a = r && me(e) ? St(e) : e;
  return qe(a) ? t.filter(function(n) {
    return qe(n) && hn(n, a) && _e(n) !== "body";
  }) : [];
}
function xs(e, t, r, a) {
  var n = t === "clippingParents" ? ws(e) : [].concat(t), o = [].concat(n, [r]), i = o[0], l = o.reduce(function(s, d) {
    var u = $a(e, d, a);
    return s.top = Me(u.top, s.top), s.right = nr(u.right, s.right), s.bottom = nr(u.bottom, s.bottom), s.left = Me(u.left, s.left), s;
  }, $a(e, i, a));
  return l.width = l.right - l.left, l.height = l.bottom - l.top, l.x = l.left, l.y = l.top, l;
}
function xn(e) {
  var t = e.reference, r = e.element, a = e.placement, n = a ? we(a) : null, o = a ? et(a) : null, i = t.x + t.width / 2 - r.width / 2, l = t.y + t.height / 2 - r.height / 2, s;
  switch (n) {
    case le:
      s = {
        x: i,
        y: t.y - r.height
      };
      break;
    case be:
      s = {
        x: i,
        y: t.y + t.height
      };
      break;
    case ge:
      s = {
        x: t.x + t.width,
        y: l
      };
      break;
    case ie:
      s = {
        x: t.x - r.width,
        y: l
      };
      break;
    default:
      s = {
        x: t.x,
        y: t.y
      };
  }
  var d = n ? Kr(n) : null;
  if (d != null) {
    var u = d === "y" ? "height" : "width";
    switch (o) {
      case Ze:
        s[d] = s[d] - (t[u] / 2 - r[u] / 2);
        break;
      case xt:
        s[d] = s[d] + (t[u] / 2 - r[u] / 2);
        break;
    }
  }
  return s;
}
function _t(e, t) {
  t === void 0 && (t = {});
  var r = t, a = r.placement, n = a === void 0 ? e.placement : a, o = r.strategy, i = o === void 0 ? e.strategy : o, l = r.boundary, s = l === void 0 ? qi : l, d = r.rootBoundary, u = d === void 0 ? pn : d, c = r.elementContext, v = c === void 0 ? lt : c, p = r.altBoundary, b = p === void 0 ? !1 : p, m = r.padding, h = m === void 0 ? 0 : m, w = gn(typeof h != "number" ? h : yn(h, Et)), A = v === lt ? Hi : lt, C = e.rects.popper, g = e.elements[b ? A : v], _ = xs(qe(g) ? g : g.contextElement || Le(e.elements.popper), s, u, i), O = Je(e.elements.reference), y = xn({
    reference: O,
    element: C,
    strategy: "absolute",
    placement: n
  }), B = Ir(Object.assign({}, C, y)), S = v === lt ? B : O, N = {
    top: _.top - S.top + w.top,
    bottom: S.bottom - _.bottom + w.bottom,
    left: _.left - S.left + w.left,
    right: S.right - _.right + w.right
  }, M = e.modifiersData.offset;
  if (v === lt && M) {
    var F = M[n];
    Object.keys(N).forEach(function(D) {
      var W = [ge, be].indexOf(D) >= 0 ? 1 : -1, X = [le, be].indexOf(D) >= 0 ? "y" : "x";
      N[D] += F[X] * W;
    });
  }
  return N;
}
function _s(e, t) {
  t === void 0 && (t = {});
  var r = t, a = r.placement, n = r.boundary, o = r.rootBoundary, i = r.padding, l = r.flipVariations, s = r.allowedAutoPlacements, d = s === void 0 ? vn : s, u = et(a), c = u ? l ? Aa : Aa.filter(function(b) {
    return et(b) === u;
  }) : Et, v = c.filter(function(b) {
    return d.indexOf(b) >= 0;
  });
  v.length === 0 && (v = c);
  var p = v.reduce(function(b, m) {
    return b[m] = _t(e, {
      placement: m,
      boundary: n,
      rootBoundary: o,
      padding: i
    })[we(m)], b;
  }, {});
  return Object.keys(p).sort(function(b, m) {
    return p[b] - p[m];
  });
}
function As(e) {
  if (we(e) === Yr)
    return [];
  var t = Wt(e);
  return [Ca(e), t, Ca(t)];
}
function Es(e) {
  var t = e.state, r = e.options, a = e.name;
  if (!t.modifiersData[a]._skip) {
    for (var n = r.mainAxis, o = n === void 0 ? !0 : n, i = r.altAxis, l = i === void 0 ? !0 : i, s = r.fallbackPlacements, d = r.padding, u = r.boundary, c = r.rootBoundary, v = r.altBoundary, p = r.flipVariations, b = p === void 0 ? !0 : p, m = r.allowedAutoPlacements, h = t.options.placement, w = we(h), A = w === h, C = s || (A || !b ? [Wt(h)] : As(h)), g = [h].concat(C).reduce(function(He, Oe) {
      return He.concat(we(Oe) === Yr ? _s(t, {
        placement: Oe,
        boundary: u,
        rootBoundary: c,
        padding: d,
        flipVariations: b,
        allowedAutoPlacements: m
      }) : Oe);
    }, []), _ = t.rects.reference, O = t.rects.popper, y = /* @__PURE__ */ new Map(), B = !0, S = g[0], N = 0; N < g.length; N++) {
      var M = g[N], F = we(M), D = et(M) === Ze, W = [le, be].indexOf(F) >= 0, X = W ? "width" : "height", Z = _t(t, {
        placement: M,
        boundary: u,
        rootBoundary: c,
        altBoundary: v,
        padding: d
      }), re = W ? D ? ge : ie : D ? be : le;
      _[X] > O[X] && (re = Wt(re));
      var Ie = Wt(re), U = [];
      if (o && U.push(Z[F] <= 0), l && U.push(Z[re] <= 0, Z[Ie] <= 0), U.every(function(He) {
        return He;
      })) {
        S = M, B = !1;
        break;
      }
      y.set(M, U);
    }
    if (B)
      for (var ae = b ? 3 : 1, tt = function(Oe) {
        var at = g.find(function($t) {
          var De = y.get($t);
          if (De)
            return De.slice(0, Oe).every(function(mr) {
              return mr;
            });
        });
        if (at)
          return S = at, "break";
      }, rt = ae; rt > 0; rt--) {
        var Ct = tt(rt);
        if (Ct === "break") break;
      }
    t.placement !== S && (t.modifiersData[a]._skip = !0, t.placement = S, t.reset = !0);
  }
}
const Ss = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: Es,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Ta(e, t, r) {
  return r === void 0 && (r = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - r.y,
    right: e.right - t.width + r.x,
    bottom: e.bottom - t.height + r.y,
    left: e.left - t.width - r.x
  };
}
function Oa(e) {
  return [le, ge, be, ie].some(function(t) {
    return e[t] >= 0;
  });
}
function Cs(e) {
  var t = e.state, r = e.name, a = t.rects.reference, n = t.rects.popper, o = t.modifiersData.preventOverflow, i = _t(t, {
    elementContext: "reference"
  }), l = _t(t, {
    altBoundary: !0
  }), s = Ta(i, a), d = Ta(l, n, o), u = Oa(s), c = Oa(d);
  t.modifiersData[r] = {
    referenceClippingOffsets: s,
    popperEscapeOffsets: d,
    isReferenceHidden: u,
    hasPopperEscaped: c
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": u,
    "data-popper-escaped": c
  });
}
const $s = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: Cs
};
function Ts(e, t, r) {
  var a = we(e), n = [ie, le].indexOf(a) >= 0 ? -1 : 1, o = typeof r == "function" ? r(Object.assign({}, t, {
    placement: e
  })) : r, i = o[0], l = o[1];
  return i = i || 0, l = (l || 0) * n, [ie, ge].indexOf(a) >= 0 ? {
    x: l,
    y: i
  } : {
    x: i,
    y: l
  };
}
function Os(e) {
  var t = e.state, r = e.options, a = e.name, n = r.offset, o = n === void 0 ? [0, 0] : n, i = vn.reduce(function(u, c) {
    return u[c] = Ts(c, t.rects, o), u;
  }, {}), l = i[t.placement], s = l.x, d = l.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += s, t.modifiersData.popperOffsets.y += d), t.modifiersData[a] = i;
}
const Bs = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: Os
};
function ks(e) {
  var t = e.state, r = e.name;
  t.modifiersData[r] = xn({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const Ls = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: ks,
  data: {}
};
function Is(e) {
  return e === "x" ? "y" : "x";
}
function Ds(e) {
  var t = e.state, r = e.options, a = e.name, n = r.mainAxis, o = n === void 0 ? !0 : n, i = r.altAxis, l = i === void 0 ? !1 : i, s = r.boundary, d = r.rootBoundary, u = r.altBoundary, c = r.padding, v = r.tether, p = v === void 0 ? !0 : v, b = r.tetherOffset, m = b === void 0 ? 0 : b, h = _t(t, {
    boundary: s,
    rootBoundary: d,
    padding: c,
    altBoundary: u
  }), w = we(t.placement), A = et(t.placement), C = !A, g = Kr(w), _ = Is(g), O = t.modifiersData.popperOffsets, y = t.rects.reference, B = t.rects.popper, S = typeof m == "function" ? m(Object.assign({}, t.rects, {
    placement: t.placement
  })) : m, N = typeof S == "number" ? {
    mainAxis: S,
    altAxis: S
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, S), M = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, F = {
    x: 0,
    y: 0
  };
  if (O) {
    if (o) {
      var D, W = g === "y" ? le : ie, X = g === "y" ? be : ge, Z = g === "y" ? "height" : "width", re = O[g], Ie = re + h[W], U = re - h[X], ae = p ? -B[Z] / 2 : 0, tt = A === Ze ? y[Z] : B[Z], rt = A === Ze ? -B[Z] : -y[Z], Ct = t.elements.arrow, He = p && Ct ? Gr(Ct) : {
        width: 0,
        height: 0
      }, Oe = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : bn(), at = Oe[W], $t = Oe[X], De = vt(0, y[Z], He[Z]), mr = C ? y[Z] / 2 - ae - De - at - N.mainAxis : tt - De - at - N.mainAxis, Tn = C ? -y[Z] / 2 + ae + De + $t + N.mainAxis : rt + De + $t + N.mainAxis, hr = t.elements.arrow && St(t.elements.arrow), On = hr ? g === "y" ? hr.clientTop || 0 : hr.clientLeft || 0 : 0, na = (D = M?.[g]) != null ? D : 0, Bn = re + mr - na - On, kn = re + Tn - na, oa = vt(p ? nr(Ie, Bn) : Ie, re, p ? Me(U, kn) : U);
      O[g] = oa, F[g] = oa - re;
    }
    if (l) {
      var la, Ln = g === "x" ? le : ie, In = g === "x" ? be : ge, Ne = O[_], Tt = _ === "y" ? "height" : "width", ia = Ne + h[Ln], sa = Ne - h[In], br = [le, ie].indexOf(w) !== -1, ua = (la = M?.[_]) != null ? la : 0, da = br ? ia : Ne - y[Tt] - B[Tt] - ua + N.altAxis, ca = br ? Ne + y[Tt] + B[Tt] - ua - N.altAxis : sa, fa = p && br ? ns(da, Ne, ca) : vt(p ? da : ia, Ne, p ? ca : sa);
      O[_] = fa, F[_] = fa - Ne;
    }
    t.modifiersData[a] = F;
  }
}
const Ns = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: Ds,
  requiresIfExists: ["offset"]
};
function Rs(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function Ps(e) {
  return e === de(e) || !me(e) ? Zr(e) : Rs(e);
}
function Ms(e) {
  var t = e.getBoundingClientRect(), r = Qe(t.width) / e.offsetWidth || 1, a = Qe(t.height) / e.offsetHeight || 1;
  return r !== 1 || a !== 1;
}
function zs(e, t, r) {
  r === void 0 && (r = !1);
  var a = me(t), n = me(t) && Ms(t), o = Le(t), i = Je(e, n, r), l = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = {
    x: 0,
    y: 0
  };
  return (a || !a && !r) && ((_e(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Jr(o)) && (l = Ps(t)), me(t) ? (s = Je(t, !0), s.x += t.clientLeft, s.y += t.clientTop) : o && (s.x = Qr(o))), {
    x: i.left + l.scrollLeft - s.x,
    y: i.top + l.scrollTop - s.y,
    width: i.width,
    height: i.height
  };
}
function Vs(e) {
  var t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), a = [];
  e.forEach(function(o) {
    t.set(o.name, o);
  });
  function n(o) {
    r.add(o.name);
    var i = [].concat(o.requires || [], o.requiresIfExists || []);
    i.forEach(function(l) {
      if (!r.has(l)) {
        var s = t.get(l);
        s && n(s);
      }
    }), a.push(o);
  }
  return e.forEach(function(o) {
    r.has(o.name) || n(o);
  }), a;
}
function qs(e) {
  var t = Vs(e);
  return Qi.reduce(function(r, a) {
    return r.concat(t.filter(function(n) {
      return n.phase === a;
    }));
  }, []);
}
function Hs(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(r) {
      Promise.resolve().then(function() {
        t = void 0, r(e());
      });
    })), t;
  };
}
function Fs(e) {
  var t = e.reduce(function(r, a) {
    var n = r[a.name];
    return r[a.name] = n ? Object.assign({}, n, a, {
      options: Object.assign({}, n.options, a.options),
      data: Object.assign({}, n.data, a.data)
    }) : a, r;
  }, {});
  return Object.keys(t).map(function(r) {
    return t[r];
  });
}
var Ba = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function ka() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return !t.some(function(a) {
    return !(a && typeof a.getBoundingClientRect == "function");
  });
}
function Ws(e) {
  e === void 0 && (e = {});
  var t = e, r = t.defaultModifiers, a = r === void 0 ? [] : r, n = t.defaultOptions, o = n === void 0 ? Ba : n;
  return function(l, s, d) {
    d === void 0 && (d = o);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Ba, o),
      modifiersData: {},
      elements: {
        reference: l,
        popper: s
      },
      attributes: {},
      styles: {}
    }, c = [], v = !1, p = {
      state: u,
      setOptions: function(w) {
        var A = typeof w == "function" ? w(u.options) : w;
        m(), u.options = Object.assign({}, o, u.options, A), u.scrollParents = {
          reference: qe(l) ? mt(l) : l.contextElement ? mt(l.contextElement) : [],
          popper: mt(s)
        };
        var C = qs(Fs([].concat(a, u.options.modifiers)));
        return u.orderedModifiers = C.filter(function(g) {
          return g.enabled;
        }), b(), p.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!v) {
          var w = u.elements, A = w.reference, C = w.popper;
          if (ka(A, C)) {
            u.rects = {
              reference: zs(A, St(C), u.options.strategy === "fixed"),
              popper: Gr(C)
            }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(N) {
              return u.modifiersData[N.name] = Object.assign({}, N.data);
            });
            for (var g = 0; g < u.orderedModifiers.length; g++) {
              if (u.reset === !0) {
                u.reset = !1, g = -1;
                continue;
              }
              var _ = u.orderedModifiers[g], O = _.fn, y = _.options, B = y === void 0 ? {} : y, S = _.name;
              typeof O == "function" && (u = O({
                state: u,
                options: B,
                name: S,
                instance: p
              }) || u);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: Hs(function() {
        return new Promise(function(h) {
          p.forceUpdate(), h(u);
        });
      }),
      destroy: function() {
        m(), v = !0;
      }
    };
    if (!ka(l, s))
      return p;
    p.setOptions(d).then(function(h) {
      !v && d.onFirstUpdate && d.onFirstUpdate(h);
    });
    function b() {
      u.orderedModifiers.forEach(function(h) {
        var w = h.name, A = h.options, C = A === void 0 ? {} : A, g = h.effect;
        if (typeof g == "function") {
          var _ = g({
            state: u,
            name: w,
            instance: p,
            options: C
          }), O = function() {
          };
          c.push(_ || O);
        }
      });
    }
    function m() {
      c.forEach(function(h) {
        return h();
      }), c = [];
    }
    return p;
  };
}
var js = [vs, Ls, fs, ts, Bs, Ss, Ns, ss, $s], Us = /* @__PURE__ */ Ws({
  defaultModifiers: js
});
function ea(e = !1) {
  const t = T(e);
  return [t, (a) => {
    t.value = a ? !!a : !t.value;
  }];
}
const Ys = ["mousedown", "touchstart"];
function Xs(e, t, r = [], a = Ys) {
  const n = (o) => {
    !r.find(
      (l) => l.value?.contains(o.target)
    ) && !e.value?.contains(o.target) && t();
  };
  At(() => {
    a.forEach((o) => document.addEventListener(o, n));
  }), Rr(() => {
    a.forEach((o) => document.removeEventListener(o, n));
  });
}
function Gs(e, t) {
  return q(t, (r) => {
    e.value = r;
  }), E(() => e.value ? e.value : t.value);
}
function Ks(e, { placement: t, offsetX: r, offsetY: a, hover: n, sameWidth: o }) {
  const i = Pe(), [l, s] = ea(f(e));
  Gs(l, e);
  const d = T(), u = T(), c = T(t.value), v = E(
    () => u.value.$el || u.value
  ), p = E(() => d.value.$el || d.value);
  Xs(v, () => !n.value && l.value && s(!1), [
    p
  ]);
  let b = null;
  const m = () => {
    b = Us(v.value, p.value, {
      placement: t.value,
      modifiers: [
        {
          name: "offset",
          options: { offset: [r.value, a.value] }
        },
        {
          name: "sameWidth",
          enabled: o.value,
          fn: ({ state: h }) => {
            h.styles.popper.width = `${h.rects.reference.width}px`;
          },
          phase: "beforeWrite",
          requires: ["computeStyles"]
        },
        {
          name: "updater",
          enabled: !0,
          phase: "main",
          fn({ state: h }) {
            c.value = h.placement, i.trigger(h);
          }
        }
      ]
    }), b.update();
  };
  return q([l, t], async ([h]) => {
    h && (await Mr(), b ? b.update() : m());
  }), At(() => {
    l.value && m();
  }), jn(() => {
    b?.destroy(), b = null;
  }), {
    referenceElement: u,
    popperElement: d,
    arrowPlacement: c,
    isOpen: l,
    toggle: s,
    onStateChange: i.on
  };
}
const Zs = $({
  name: "NPopper",
  inheritAttrs: !1,
  props: {
    modelValue: {
      type: Boolean,
      default: !1
    },
    placement: {
      type: String,
      default: "bottom",
      validator(e) {
        return Vi.includes(e);
      }
    },
    offsetX: {
      type: [String, Number],
      default: 0
    },
    offsetY: {
      type: [String, Number],
      default: 0
    },
    hover: {
      type: Boolean,
      default: !1
    },
    arrow: {
      type: Boolean,
      default: !1
    },
    arrowClass: {
      type: [String, Array],
      default: "before:bg-white"
    },
    arrowRightClass: {
      type: [String, Array],
      default: ""
    },
    arrowLeftClass: {
      type: [String, Array],
      default: ""
    },
    arrowTopClass: {
      type: [String, Array],
      default: ""
    },
    arrowBottomClass: {
      type: [String, Array],
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    appendToBody: {
      type: Boolean,
      default: !1
    },
    sameWidth: {
      type: Boolean,
      default: !1
    },
    wrapperClass: {
      type: String,
      default: ""
    },
    clickPersist: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue", "update"],
  setup(e, { emit: t }) {
    const {
      modelValue: r,
      placement: a,
      offsetX: n,
      offsetY: o,
      hover: i,
      disabled: l,
      sameWidth: s,
      clickPersist: d
    } = ue(e), {
      referenceElement: u,
      arrowPlacement: c,
      popperElement: v,
      isOpen: p,
      toggle: b,
      onStateChange: m
    } = Ks(r, {
      placement: a,
      offsetX: n,
      offsetY: o,
      hover: i,
      sameWidth: s
    });
    return q(p, (C) => {
      t("update:modelValue", C);
    }), m((C) => {
      t("update", C);
    }), {
      referenceElement: u,
      popperElement: v,
      isOpen: p,
      arrowPlacement: c,
      handleOnClick: () => {
        if (!l.value && !i.value)
          return d.value ? b(!0) : b();
      },
      handleOnMouseEnter: () => !l.value && i.value && b(!0),
      handleOnMouseLeave: () => !l.value && i.value && b(!1)
    };
  },
  render() {
    const {
      $slots: e,
      appendToBody: t,
      handleOnClick: r,
      handleOnMouseEnter: a,
      handleOnMouseLeave: n
    } = this, o = Ni(e.default(), {
      ref: "referenceElement",
      onclick: r,
      onmouseenter: a,
      onmouseleave: n
    }), i = zi(this);
    return K(he, null, [
      o,
      K(zr, { to: "body", disabled: !t }, [i])
    ]);
  }
}), ht = Zs;
ht.install = (e) => {
  e.component(ht.name, ht);
};
const Qs = {
  none: "shadow-none",
  mini: "shadow-mini",
  small: "shadow-small",
  medium: "shadow-medium",
  large: "shadow-large",
  maxi: "shadow-maxi"
}, Ar = {
  default: "bg-neutral-primary",
  disabled: "bg-neutral-primary-disable pointer-events-none",
  active: "cursor-pointer active:bg-neutral-primary-press active:shadow-none"
}, Js = $({ name: "NBox" }), Ue = /* @__PURE__ */ $({
  ...Js,
  props: {
    as: { default: "div" },
    rounded: { type: Boolean, default: !0 },
    elevation: { default: "small" },
    disabled: { type: Boolean, default: !1 },
    activeStyle: { type: Boolean, default: !1 },
    border: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, r = E(() => [
      {
        [Qs[t.elevation]]: !t.disabled,
        [Ar.disabled]: t.disabled,
        [Ar.active]: t.activeStyle,
        [Ar.default]: !t.disabled,
        "rounded-md": t.rounded,
        "border border-solid border-neutral-primary": t.border
      }
    ]);
    return (a, n) => (x(), P(lr(a.as), {
      class: k(r.value)
    }, {
      default: V(() => [
        R(a.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
});
Ue.install = (e) => {
  e.component(Ue.name, Ue);
};
const eu = "inline-flex items-center rounded-3xl group px-3", tu = {
  green: "bg-brand-secondary text-brand-quaternary hover:bg-brand-secondary-hover hover:text-brand-quaternary-hover active:bg-brand-secondary-press active:text-brand-quaternary-press border-transparent",
  blue: "bg-blue-20 hover:bg-blue-30 active:bg-blue-40 text-blue-140 hover:text-blue-150 active:text-blue-170 border-transparent",
  red: "bg-critical-secondary text-critical-secondary hover:bg-critical-secondary-hover hover:text-critical-secondary-hover active:bg-critical-secondary-press active:text-critical-secondary-press border-transparent",
  gray: "bg-neutral-secondary-hover text-neutral-secondary hover:bg-neutral-secondary-hover hover:text-neutral-primary active:bg-neutral-secondary-press active:text-neutral-primary border-transparent"
}, ru = {
  green: "text-brand-primary border border-brand-primary hover:text-brand-primary-hover hover:border-brand-primary-hover active:text-brand-primary-press active:border-brand-primary-press",
  red: "text-critical-primary border border-critical-primary hover:text-critical-primary-hover hover:border-critical-primary-press active:text-critical-primary-press active:border-critical-primary-press",
  blue: "text-blue-140 hover:text-blue-150 active:text-blue-170 border border-blue-40 hover:border-blue-60 active:border-blue-80 ",
  gray: "text-neutral-primary border border-neutral-tertiary hover:border-neutral-tertiary-hover active:border-neutral-tertiary-press"
}, au = {
  green: "text-brand-primary hover:text-brand-primary-hover active:text-brand-primary-press",
  red: "text-critical-primary hover:text-critical-primary-hover active:text-critical-primary-press",
  blue: "text-blue-140 hover:text-blue-150 active:text-blue-170",
  gray: "text-neutral-primary hover:text-neutral-primary-hover active:text-neutral-primary-press"
}, nu = {
  small: "h-6 text-o",
  middle: "h-8 text-c1"
}, ou = {
  small: 16,
  middle: 20
}, lu = {
  key: 0,
  class: "me-1 rtl:-mr-0.5 ltr:-ml-0.5"
}, iu = $({ name: "NCheap" }), bt = /* @__PURE__ */ $({
  ...iu,
  props: {
    modelValue: { type: Boolean, default: void 0 },
    variant: { default: "fill" },
    closable: { type: Boolean, default: !0 },
    showIcon: { type: Boolean },
    label: { default: "" },
    size: { default: "middle" },
    color: { default: "gray" },
    selectable: { type: Boolean, default: !1 }
  },
  emits: ["close", "update:modelValue"],
  setup(e, { emit: t }) {
    const r = e, a = t, n = E(() => ({
      root: [
        eu,
        nu[r.size],
        r.variant === "fill" && tu[r.color],
        r.variant === "plain" && au[r.color],
        r.variant === "outline" && ru[r.color]
      ]
    })), o = () => {
      r.selectable && !r.modelValue && a("update:modelValue", !r.modelValue);
    };
    return (i, l) => (x(), I("div", {
      class: k(n.value.root)
    }, [
      L("div", {
        class: "inline-flex items-center",
        onClick: o
      }, [
        i.showIcon ? (x(), I("div", lu, [
          R(i.$slots, "icon")
        ])) : z("", !0),
        i.label ? (x(), P(f(J), {
          key: 1,
          variant: i.size === "middle" ? "caption1" : "overline",
          weight: "medium"
        }, {
          default: V(() => [
            Q(ee(i.label), 1)
          ]),
          _: 1
        }, 8, ["variant"])) : z("", !0)
      ]),
      i.closable ? (x(), I("span", {
        key: 0,
        class: "cursor-pointer ps-1 rtl:-ml-0.5 ltr:-mr-0.5",
        onClick: l[0] || (l[0] = Xe((s) => a("close"), ["stop"]))
      }, [
        j(f(Wa), {
          size: f(ou)[i.size]
        }, null, 8, ["size"])
      ])) : z("", !0)
    ], 2));
  }
});
bt.install = (e) => {
  e.component(bt.name, bt);
};
var jt = /* @__PURE__ */ ((e) => (e.Start = "start", e.End = "end", e))(jt || {});
const su = "bg-neutral-primary w-7 h-full rounded-full transition-all ring-opacity-10", uu = "absolute w-full h-full inset-0 opacity-0 cursor-pointer", du = { class: "flex gap-3 items-center" }, cu = ["id", "aria-checked", "checked", "aria-disabled", "disabled"], fu = ["for"], pu = $({ name: "NSwitch" }), Ut = /* @__PURE__ */ $({
  ...pu,
  props: {
    modelValue: { type: Boolean, default: void 0 },
    disabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    label: { default: "" },
    labelPosition: { default: jt.End }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const r = t, a = e, n = Te("switch-"), { modelValue: o } = ue(a), [i, l] = ea(!1), s = ir(o, !!f(o)), d = ({ target: c }) => {
      r("update:modelValue", c.checked);
    }, u = E(() => ({
      track: {
        "bg-neutral-secondary-hover": !a.disabled && !s.value,
        "bg-brand-primary": !a.disabled && s.value,
        "bg-brand-primary-hover": !a.disabled && s.value && i.value,
        "bg-neutral-quaternary-disable": a.disabled && !s.value,
        "bg-brand-primary-disable": a.disabled && s.value
      },
      thumb: [
        su,
        {
          "translate-x-6 ring-brand-primary-hover": s.value,
          "ring-brand-primary-hover": !s.value,
          "ring-8": i.value,
          "bg-neutral-secondary-press": a.disabled,
          "ring-0": a.disabled
        }
      ],
      input: [
        uu,
        {
          "cursor-not-allowed": a.disabled,
          "cursor-wait": a.loading
        }
      ]
    }));
    return (c, v) => (x(), I("div", du, [
      L("div", {
        class: k(["relative shrink-0 w-14 h-8", {
          "order-2": c.labelPosition === f(jt).Start
        }])
      }, [
        L("div", {
          dir: "ltr",
          class: k(["w-full h-full p-0.5 rounded-full", u.value.track])
        }, [
          L("div", {
            class: k(u.value.thumb)
          }, [
            c.loading ? (x(), P(f(ke), {
              key: 0,
              class: "text-neutral-secondary",
              size: 14
            })) : z("", !0)
          ], 2)
        ], 2),
        L("input", {
          id: f(n),
          class: k(u.value.input),
          "aria-checked": f(s),
          checked: f(s),
          "aria-disabled": c.disabled,
          disabled: c.disabled || c.loading,
          role: "switch",
          type: "checkbox",
          onMouseenter: v[0] || (v[0] = (p) => f(l)(!0)),
          onMouseleave: v[1] || (v[1] = (p) => f(l)(!1)),
          onInput: d
        }, null, 42, cu)
      ], 2),
      L("label", {
        for: f(n),
        class: k([
          "text-c1",
          {
            "order-1": c.labelPosition === f(jt).Start
          }
        ])
      }, [
        R(c.$slots, "default", {}, () => [
          Q(ee(c.label), 1)
        ])
      ], 10, fu)
    ]));
  }
});
Ut.install = (e) => {
  e.component(Ut.name, Ut);
};
var Yt = /* @__PURE__ */ ((e) => (e.Default = "default", e.Index = "index", e))(Yt || {}), xe = /* @__PURE__ */ ((e) => (e.Medium = "medium", e.Small = "small", e))(xe || {});
function Dr(e, t, r) {
  if (!t)
    return;
  const n = (Array.isArray(t) ? t : t.match(/([^[.\]])+/g) || []).reduce(
    (o, i) => o && o[i],
    e
  );
  return n === void 0 ? r : n;
}
var pe = /* @__PURE__ */ ((e) => (e.Ascending = "ascending", e.Descending = "descending", e.Default = "default", e))(pe || {});
function vu(e, t, r, a) {
  if (!t || Array.isArray(t) && !t.length)
    return e;
  const n = new Intl.Collator(r, {
    sensitivity: "accent",
    usage: "sort"
  }), o = Array.isArray(t) ? t : [t];
  return [...e].sort((i, l) => {
    for (const { prop: s, order: d } of o) {
      let u = Dr(i, s), c = Dr(l, s);
      if (d === "descending" && ([u, c] = [c, u]), a && a[s]) {
        const v = a[s](u, c);
        if (!v) continue;
        return v;
      }
      if (!(u === null && c === null)) {
        if (u instanceof Date && c instanceof Date)
          return u.getTime() - c.getTime();
        if ([u, c] = [u, c].map(
          (v) => (v || "").toString().toLocaleLowerCase()
        ), u !== c)
          return !isNaN(u) && !isNaN(c) ? Number(u) - Number(c) : n.compare(u, c);
      }
    }
    return 0;
  });
}
const mu = {
  [xe.Small]: 37,
  [xe.Medium]: 42
}, hu = "bg-neutral-secondary flex justify-center items-center w-6 h-6 rounded-full", bu = ["tabindex"], gu = $({ name: "NTableColumn" }), gt = /* @__PURE__ */ $({
  ...gu,
  props: {
    prop: { default: "" },
    label: { default: "" },
    type: { default: Yt.Default },
    sortable: { type: Boolean, default: !1 },
    sorter: { default: void 0 },
    align: { default: "text-center" }
  },
  setup(e) {
    const t = e, { row: r, index: a, isClickable: n } = wu(), { columnSplitter: o, cellPadding: i } = ta(), l = E(() => ({
      index: hu,
      "p-3": i === xe.Medium,
      "p-2": i === xe.Small,
      "w-12": t.type === Yt.Index,
      "first:border-r-0 border-r border-neutral-secondary": o
    }));
    return (s, d) => f(r) ? (x(), I("td", {
      key: 0,
      tabindex: f(n) ? "" : 0,
      class: k([s.align, l.value])
    }, [
      R(s.$slots, "default", {
        row: f(r),
        index: f(a)
      }, () => [
        s.type === f(Yt).Index ? (x(), P(f(J), {
          key: 0,
          weight: "medium",
          variant: "caption2",
          class: k(l.value.index)
        }, {
          default: V(() => [
            Q(ee(f(a) + 1), 1)
          ]),
          _: 1
        }, 8, ["class"])) : (x(), I(he, { key: 1 }, [
          Q(ee(f(Dr)(f(r), s.prop)), 1)
        ], 64))
      ])
    ], 10, bu)) : z("", !0);
  }
}), _n = Symbol("TableContext");
function ta() {
  const e = ye(_n);
  if (!e)
    throw new Error(
      "The useTableContext hook must be used within <Table /> component."
    );
  return e;
}
function yu(e) {
  const t = ue(e), a = Nr().default?.().filter?.((O) => O.type === gt).map((O) => {
    const y = O.props;
    return {
      ...y,
      sortable: y?.sortable !== void 0,
      align: y?.align || "text-center"
    };
  }) || [], n = a.reduce(
    (O, y) => y.sorter && y.prop ? {
      ...O,
      [y.prop]: y.sorter
    } : O,
    {}
  ), {
    state: o,
    add: i,
    remove: l,
    toggle: s,
    isActive: d,
    onStateChange: u,
    onItemAdd: c,
    onItemRemove: v
  } = sr({
    initialState: e.sortBy,
    syncStateFrom: t.sortBy,
    multiple: t.sortMultiple,
    isEqual: (O, y) => {
      try {
        return O.prop === y.prop;
      } catch {
        return !1;
      }
    }
  }), p = e.sortFunction || vu, b = E(
    () => p(e.data, o.value, qr.getLocale(), n)
  ), {
    list: m,
    containerProps: h,
    wrapperProps: w,
    scrollTo: A
  } = cl(e.virtualScroll ? b : E(() => []), {
    itemHeight: mu[e.cellPadding],
    overscan: Math.max(Math.ceil(b.value.length / 20), 8)
  }), C = E(
    () => e.virtualScroll ? m.value.map(({ data: O }) => O) : b.value
  );
  function g({ prop: O, value: y }) {
    const B = b.value.findIndex((S) => S[O] === y);
    B > -1 && A(B);
  }
  const _ = {
    columns: a,
    fixedHeader: e.fixedHeader,
    striped: e.striped,
    cellPadding: e.cellPadding,
    externalRowClass: e.rowClass,
    isRowClickable: e.isRowClickable,
    onRowClick: e.onRowClick,
    rowSplitter: e.rowSplitter,
    bodySplitter: e.bodySplitter,
    columnSplitter: e.columnSplitter,
    sortBy: o,
    sortMultiple: t.sortMultiple,
    addSort: i,
    removeSort: l,
    toggleSort: s,
    isSorted: d,
    onSortByChange: u,
    onSortAdd: c,
    onSortRemove: v
  };
  return Ae(_n, _), {
    columns: a,
    computedData: C,
    virtualContainerProps: e.virtualScroll ? h : void 0,
    virtualWrapperProps: e.virtualScroll ? w : void 0,
    virtualScrollTo: g,
    onSortByChange: u,
    onSortAdd: c,
    onSortRemove: v
  };
}
const An = Symbol("TableRowContext");
function wu() {
  const e = ye(An);
  if (!e)
    throw new Error(
      "The useTableRowContext hook must be used within <TableRow /> component."
    );
  return e;
}
function xu(e) {
  const t = ue(e), { isRowClickable: r, externalRowClass: a, onRowClick: n } = ta(), o = E(
    () => r(t.row.value) && !!n
  ), i = E(() => a(t.row.value));
  return Ae(An, { ...t, isClickable: o }), {
    isClickable: o,
    externalClass: i
  };
}
const _u = ["tabindex"], Au = $({ name: "NTableRow" }), yt = /* @__PURE__ */ $({
  ...Au,
  props: {
    row: { default: void 0 },
    index: { default: void 0 },
    onRowClick: { type: Function, default: void 0 },
    highlighted: { type: Boolean, default: !1 },
    striped: { type: Boolean, default: !1 },
    rowSplitter: { type: Boolean, default: !0 },
    showLoading: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, { isClickable: r, externalClass: a } = xu(t), n = E(() => t.index % 2 !== 0), o = E(() => ({
      "bg-neutral-secondary": t.striped && n.value,
      "border-b border-t border-neutral-secondary": t.rowSplitter && n.value,
      "cursor-pointer": r.value,
      "!bg-brand-primary-press !bg-opacity-20 darkTheme:!bg-opacity-25": t.highlighted,
      "last:border-b-0": !t.showLoading
    })), i = () => {
      r.value && t.onRowClick?.(t.row);
    };
    return (l, s) => (x(), I("tr", {
      tabindex: f(r) ? 0 : "",
      class: k(["group relative border-b border-neutral-secondary hover:bg-neutral-secondary-hover active:bg-brand-primary-press darkTheme:active:bg-opacity-25 active:bg-opacity-20 outline-none", [o.value, f(a)]]),
      onClick: i
    }, [
      R(l.$slots, "default")
    ], 10, _u));
  }
});
yt.install = (e) => {
  e.component(yt.name, yt);
};
const Eu = "inline-block relative w-3 h-3 align-middle text-neutral-tertiary", Su = "align-middle inline-flex items-center justify-center w-4 h-4 ms-1 bg-brand-primary rounded-full", Cu = $({ name: "NTableHeader" }), Xt = /* @__PURE__ */ $({
  ...Cu,
  props: {
    column: {}
  },
  setup(e) {
    const t = e, {
      sortMultiple: r,
      sortBy: a,
      isSorted: n,
      addSort: o,
      removeSort: i,
      toggleSort: l,
      cellPadding: s
    } = ta(), d = ze({
      prop: t.column.prop,
      order: pe.Default
    }), u = {
      [pe.Ascending]: {
        next: () => {
          i(d), d.order = pe.Descending, o(d);
        }
      },
      [pe.Descending]: {
        next: () => {
          l(d), d.order = pe.Default;
        }
      },
      [pe.Default]: {
        next: () => {
          l(d), d.order = pe.Ascending;
        }
      }
    }, c = () => {
      t.column.sortable && u[d.order].next();
    }, v = E(() => r.value ? a.value.findIndex((m) => m.prop === t.column.prop) + 1 : -1);
    q(
      a,
      () => {
        if (n(d)) {
          let m = a.value;
          r.value && (m = a.value.find(
            (h) => h.prop === d.prop
          )), (d !== m || d.order === pe.Default) && (d.order = m.order);
        } else
          d.order = pe.Default;
      },
      { immediate: !0, deep: !0 }
    );
    const p = E(() => ({
      cell: [
        "whitespace-nowrap",
        {
          "p-2": s === xe.Small,
          "p-3": s === xe.Medium
        }
      ],
      ascending: { "text-brand-primary": d.order === pe.Ascending },
      descending: {
        "text-brand-primary": d.order === pe.Descending
      }
    })), b = () => Cr(t.column.label) ? t.column.label : K(
      J,
      {
        weight: "bold",
        variant: "overline"
      },
      () => [
        t.column.label ? t.column.label : t.column.type === "index" ? "#" : ""
      ]
    );
    return (m, h) => (x(), I("th", {
      scope: "col",
      tabindex: "0",
      class: k([
        p.value.cell,
        m.column.align,
        {
          "cursor-pointer": m.column.sortable
        }
      ]),
      onClick: h[0] || (h[0] = (w) => m.column.sortable ? c() : null)
    }, [
      j(b),
      m.column.sortable ? (x(), I("span", {
        key: 0,
        class: k(f(Eu))
      }, [
        j(f(qo), {
          class: k(["absolute -top-2", p.value.descending]),
          size: "20"
        }, null, 8, ["class"]),
        j(f(Vo), {
          class: k(["absolute -bottom-2", p.value.ascending]),
          size: "20"
        }, null, 8, ["class"])
      ], 2)) : z("", !0),
      f(r) && f(a).length > 1 && v.value ? (x(), P(f(J), {
        key: 1,
        variant: "caption2",
        class: k(f(Su))
      }, {
        default: V(() => [
          Q(ee(v.value), 1)
        ]),
        _: 1
      }, 8, ["class"])) : z("", !0)
    ], 2));
  }
});
Xt.install = (e) => {
  e.component(Xt.name, Xt);
};
const $u = "border-collapse border-spacing-0 w-full rtl:text-right text-left text-c2 bg-neutral-primary", Tu = { class: "border-b border-neutral-secondary" }, Ou = ["colspan"], Bu = ["colspan"], { t: La } = pr(), ku = $({ name: "NTable" }), Gt = /* @__PURE__ */ $({
  ...ku,
  props: {
    data: { default: () => [] },
    rowSplitter: { type: Boolean, default: !0 },
    columnSplitter: { type: Boolean, default: !0 },
    bodySplitter: { type: Boolean, default: !0 },
    cellPadding: { default: xe.Medium },
    isRowClickable: { type: Function, default: () => !0 },
    onRowClick: { type: Function, default: void 0 },
    rowClass: { type: Function, default: () => "" },
    noDataText: { default: La("table.noData") },
    noResultText: { default: La("table.noResult") },
    striped: { type: Boolean, default: !0 },
    sortBy: { default: void 0 },
    highlightBy: { default: void 0 },
    sortMultiple: { type: Boolean, default: !1 },
    sortFunction: {},
    fixedHeader: { type: Boolean, default: !1 },
    hoverAlignment: { default: "left" },
    hoverOffset: { default: "0" },
    virtualScroll: { type: Boolean, default: !1 },
    showLoading: { type: Boolean, default: !1 },
    indexKey: {}
  },
  emits: ["update:sortBy", "sortAdd", "sortRemove"],
  setup(e, { expose: t, emit: r }) {
    const a = r, n = e, {
      computedData: o,
      columns: i,
      onSortAdd: l,
      onSortRemove: s,
      onSortByChange: d,
      virtualContainerProps: u,
      virtualWrapperProps: c,
      virtualScrollTo: v
    } = yu(n), p = T(), b = T();
    l((h) => a("sortAdd", h)), s((h) => a("sortRemove", h)), d((h) => a("update:sortBy", h));
    const m = (h) => {
      if (!n.highlightBy || un(n.highlightBy.value)) return !1;
      const { prop: w, value: A } = n.highlightBy;
      return Array.isArray(A) ? A?.findIndex((C) => h[w] === C) > -1 : h[w] === A;
    };
    return rl(
      [Y.ArrowUp, Y.ArrowDown],
      (h) => {
        if (h.target) {
          const w = {
            [Y.ArrowUp]: "previousElementSibling",
            [Y.ArrowDown]: "nextElementSibling"
          }, A = h.target[w[h.key]];
          A && (A.click(), A.focus());
        }
      },
      { target: p }
    ), t({ virtualScrollTo: v, loadingRef: b }), (h, w) => (x(), I("div", ne({
      class: ["rounded-md h-full overflow-auto", {
        "border border-neutral-tertiary": h.bodySplitter
      }]
    }, f(u)), [
      L("div", ne(f(c), { class: "relative" }), [
        L("table", {
          ref_key: "tableRef",
          ref: p,
          class: k(f($u))
        }, [
          L("thead", {
            class: k([{ "sticky top-0 z-50": h.fixedHeader }, "bg-neutral-primary"])
          }, [
            L("tr", Tu, [
              (x(!0), I(he, null, Ge(f(i), (A, C) => (x(), P(f(Xt), {
                key: C,
                column: A
              }, null, 8, ["column"]))), 128))
            ]),
            L("tr", null, [
              L("th", {
                class: "h-[1px] bg-neutral-primary p-0",
                colspan: f(i).length
              }, null, 8, Ou)
            ])
          ], 2),
          L("tbody", null, [
            f(o).length ? (x(!0), I(he, { key: 0 }, Ge(f(o), (A, C) => (x(), P(f(yt), {
              key: h.indexKey ? A[h.indexKey] : C,
              row: A,
              index: C,
              "on-row-click": h.onRowClick,
              highlighted: m(A),
              striped: h.striped,
              "row-splitter": h.rowSplitter,
              "show-loading": h.showLoading
            }, {
              default: V(() => [
                R(h.$slots, "default"),
                h.$slots.hoveredElements ? (x(), I("div", {
                  key: 0,
                  class: k(["hidden group-hover:flex items-center justify-end gap-1 absolute rtl:left-0 ltr:right-0 w-fit h-[calc(100%_+_1px)] z-40 pr-16", {
                    "p-3": h.cellPadding === f(xe).Medium,
                    "p-2": h.cellPadding === f(xe).Small,
                    "rtl:left-0 ltr:right-0 rtl:pr-16 ltr:pl-16": h.hoverAlignment === "left",
                    "rtl:right-0 ltr:left-0 rtl:px-16 ltr:pr-16": h.hoverAlignment === "right",
                    "bg-[linear-gradient(270deg,_#f3f3f300_0%,_#f3f3f3_24%)] darkTheme:bg-[linear-gradient(90deg,_#181818_38.49%,_#81818100_100%)]": h.hoverAlignment === "left",
                    "bg-[linear-gradient(90deg,_#f3f3f300_0%,_#f3f3f3_24%,_#f3f3f3_76%,_#f3f3f300_100%)] darkTheme:bg-[linear-gradient(90deg,_#81818100_0%,_#181818_24%,_#181818_76%,_#81818100_100%)]": h.hoverAlignment === "right"
                  }]),
                  style: Ce({
                    [h.hoverAlignment]: h.hoverOffset
                  })
                }, [
                  R(h.$slots, "hoveredElements", { row: A })
                ], 6)) : z("", !0)
              ]),
              _: 2
            }, 1032, ["row", "index", "on-row-click", "highlighted", "striped", "row-splitter", "show-loading"]))), 128)) : (x(), P(f(yt), { key: 1 }, {
              default: V(() => [
                R(h.$slots, "default"),
                L("td", {
                  colspan: f(i).length,
                  class: "py-6 text-center text-md text-gray-40"
                }, [
                  h.data.length ? R(h.$slots, "noResult", { key: 1 }, () => [
                    Q(ee(h.noResultText), 1)
                  ]) : R(h.$slots, "noData", { key: 0 }, () => [
                    Q(ee(h.noDataText), 1)
                  ])
                ], 8, Bu)
              ]),
              _: 3
            }))
          ])
        ], 2)
      ], 16),
      h.showLoading ? (x(), I("div", {
        key: 0,
        ref_key: "loadingRef",
        ref: b,
        class: "flex justify-center p-2 bg-neutral-primary"
      }, [
        j(f(ke), { class: "text-brand-primary" })
      ], 512)) : z("", !0)
    ], 16));
  }
});
Gt.install = (e) => {
  e.component(Gt.name, Gt);
};
gt.install = (e) => {
  e.component(gt.name, gt);
};
const En = Symbol("TabsContext");
function Lu() {
  const e = ye(En);
  if (!e)
    throw new Error(
      "The useTabsContext hook must be used within <Tabs /> component."
    );
  return e;
}
function Iu(e, t) {
  const {
    isActive: r,
    add: a,
    onStateChange: n
  } = sr({
    initialState: t.modelValue,
    syncStateFrom: ue(t).modelValue,
    mandatory: T(!0)
  }), { autoActivate: o, variant: i } = ue(t), l = Te("tabpanel-wrapper-"), { direction: s } = za();
  function d(p, b) {
    const m = e.value.findIndex((w) => p === w.element), h = Ve(b)({
      currentIndex: m,
      total: e.value.length,
      shouldIgnoreIndex(w) {
        return e.value[w].disabled;
      }
    });
    e.value[h].element?.focus();
  }
  function u(p, b) {
    const m = e.value.findIndex((w) => p === w.element), h = Ve(b)({
      currentIndex: m,
      total: e.value.length,
      shouldIgnoreIndex(w) {
        return e.value[w].disabled;
      }
    });
    e.value[h].element?.focus(), a(h);
  }
  function c({ target: p, code: b }) {
    const m = {
      rtl: {
        [Y.ArrowLeft]: Y.ArrowRight,
        [Y.ArrowRight]: Y.ArrowLeft
      }
    }[s.value]?.[b] || b, h = o.value ? u : d, w = {
      [Y.ArrowLeft]: () => h(p, m),
      [Y.ArrowRight]: () => h(p, m)
    };
    w[m] && w[m]();
  }
  return Ae(En, {
    isTabActive: r,
    activateTab: a,
    tabpanelWrapperId: l,
    variant: i
  }), {
    tabpanelWrapperId: l,
    onActiveTabChange: n,
    handleKeyDown: c
  };
}
const Du = "text-c1 px-3 md:px-2 py-1.5 flex flex-1 gap-2 justify-center items-center outline-0 whitespace-nowrap font-bold", Nu = {
  default: {
    default: "bg-neutral-primary text-brand-primary border border-brand-primary hover:border-brand-primary-hover hover:text-brand-primary-hover hover:bg-neutral-primary-hover",
    red: "bg-critical-secondary text-critical-secondary border border-critical-primary hover:bg-critical-secondary-hover hover:text-critical-secondary-hover",
    green: "bg-brand-secondary text-brand-primary border border-brand-primary hover:text-brand-primary-hover hover:border-brand-primary-hover hover:bg-brand-secondary-hover"
  },
  underline: {
    default: "border-b-2 border-brand-primary text-brand-primary hover:border-brand-primary-hover hover:text-brand-primary-hover",
    red: "bg-critical-secondary border-b-2 border-critical-primary text-critical-secondary hover:bg-critical-secondary-hover hover:border-critical-secondary-hover hover:text-critical-secondary-hover",
    green: "bg-brand-secondary border-b-2 border-brand-primary text-brand-primary hover:border-brand-primary-hover hover:text-brand-primary-hover hover:bg-brand-secondary-hover"
  }
}, Ru = {
  default: {
    default: "bg-neutral-secondary-disable cursor-not-allowed text-neutral-primary-disable",
    red: "bg-critical-secondary-disable cursor-not-allowed text-critical-secondary-disable",
    green: "bg-brand-primary-disable cursor-not-allowed text-brand-primary-disable"
  },
  underline: {
    default: "bg-neutral-primary-disable cursor-not-allowed border-b-2 border-neutral-secondary-disable text-neutral-tertiary-disable",
    red: "cursor-not-allowed border-b-2 border-neutral-primary-disable text-critical-primary-disable",
    green: "bg-brand-secondary-disable cursor-not-allowed border-b-2 border-brand-secondary-disable text-brand-primary-disable"
  }
}, Pu = {
  default: {
    default: "bg-neutral-secondary text-neutral-secondary hover:bg-neutral-secondary-hover hover:text-neutral-secondary-hover",
    red: "bg-neutral-quinary text-critical-primary hover:bg-critical-secondary-press hover:text-critical-secondary-press",
    green: "bg-neutral-quinary text-brand-primary hover:bg-brand-secondary hover:text-brand-primary-hover"
  },
  underline: {
    default: "border-b-2 border-neutral-quaternary text-neutral-secondary hover:border-neutral-secondary-hover hover:text-neutral-secondary-hover",
    red: "border-b-2 border-critical-primary text-critical-primary hover:bg-critical-secondary",
    green: "border-b-2 border-neutral-tertiary text-brand-primary hover:border-gray-60 hover:text-brand-primary-hover hover:bg-brand-secondary-hover hover:border-neutral-secondary-hover"
  }
}, Mu = {
  none: "rounded-none",
  medium: "rounded-md",
  full: "rounded-full"
}, zu = {
  right: "justify-start",
  center: "justify-center",
  left: "justify-end"
}, Vu = ["id"], qu = $({ name: "NTabs", inheritAttrs: !1 }), Kt = /* @__PURE__ */ $({
  ...qu,
  props: {
    modelValue: { default: 0 },
    variant: { default: "default" },
    autoActivate: { type: Boolean, default: !1 },
    align: { default: "right" },
    containerClass: { default: "" },
    contentClass: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const r = e, a = t, { descendants: n } = dr(), { onActiveTabChange: o, tabpanelWrapperId: i, handleKeyDown: l } = Iu(
      n,
      r
    );
    return o((s) => {
      a("update:modelValue", s);
    }), (s, d) => (x(), I("div", {
      class: k(["flex flex-col h-full w-full", s.containerClass])
    }, [
      L("div", {
        class: k(["flex mb-2", f(zu)[s.align]])
      }, [
        L("div", ne({ role: "tablist" }, s.$attrs, {
          class: ["inline-flex scrolling-touch overflow-auto self-start md:overflow-hidden", { "gap-2": s.variant === "default" }],
          onKeydown: d[0] || (d[0] = Xe(
            //@ts-ignore
            (...u) => f(l) && f(l)(...u),
            ["stop"]
          ))
        }), [
          R(s.$slots, "default")
        ], 16)
      ], 2),
      L("div", {
        id: f(i),
        class: k(["h-full overflow-auto", s.contentClass])
      }, null, 10, Vu)
    ], 2));
  }
});
Kt.install = (e) => {
  e.component(Kt.name, Kt);
};
const Hu = ["id", "tabindex", "disabled", "aria-selected", "aria-controls", "aria-disabled"], Fu = ["id", "aria-labelledby"], Wu = $({ name: "NTab" }), Zt = /* @__PURE__ */ $({
  ...Wu,
  props: {
    title: { default: "" },
    disabled: { type: Boolean, default: !1 },
    color: { default: "default" },
    rounded: { default: "medium" }
  },
  setup(e) {
    const t = e, r = Te("tabpanel-"), { isTabActive: a, activateTab: n, tabpanelWrapperId: o, variant: i } = Lu(), { ref: l, index: s, id: d } = ur({ ...t, idPrefix: "tab-" }), u = E(() => a(s.value)), c = E(() => ({
      tab: [
        Du,
        i.value === "default" && Mu[t.rounded],
        {
          [Nu[i.value][t.color]]: u.value,
          [Ru[i.value][t.color]]: t.disabled,
          [Pu[i.value][t.color]]: !t.disabled && !u.value
        }
      ]
    }));
    return (v, p) => (x(), I("button", {
      id: f(d),
      ref_key: "ref",
      ref: l,
      type: "button",
      role: "tab",
      tabindex: u.value ? 0 : -1,
      disabled: v.disabled,
      "aria-selected": u.value,
      "aria-controls": f(r),
      "aria-disabled": v.disabled,
      class: k(c.value.tab),
      onClick: p[0] || (p[0] = (b) => f(n)(f(s)))
    }, [
      R(v.$slots, "prepend", { isActive: u.value }),
      R(v.$slots, "title", { isActive: u.value }, () => [
        Q(ee(v.title), 1)
      ]),
      R(v.$slots, "append", { isActive: u.value }),
      u.value && v.$slots.default ? (x(), P(zr, {
        key: 0,
        to: `#${f(o)}`
      }, [
        L("div", {
          id: f(r),
          role: "tabpanel",
          tabindex: "0",
          "aria-labelledby": f(d),
          class: "h-full flex flex-col"
        }, [
          R(v.$slots, "default")
        ], 8, Fu)
      ], 8, ["to"])) : z("", !0)
    ], 10, Hu));
  }
});
Zt.install = (e) => {
  e.component(Zt.name, Zt);
};
const Sn = Symbol("DialogContext");
function Cn() {
  const e = ye(Sn);
  if (!e)
    throw new Error(
      "useDialog must be used within a app with registered NDialog plugin"
    );
  return e;
}
const ra = -1, aa = 60, ju = 190, Se = T([]), je = T(), Qt = T(ra), Be = T(aa);
q(
  Se,
  () => {
    Se.value.length === 0 && (Qt.value = ra, Be.value = aa);
  },
  {
    deep: !0
  }
);
const or = {
  lastMultiDialogZIndex: Be,
  selectedDialogId: je,
  dialogs: Se,
  add: (e) => {
    const t = Te("dialog-");
    return Qt.value++, e.multiple && Be.value++, Se.value.push({
      ...e,
      id: t,
      index: Qt.value,
      zIndex: e.multiple ? Be.value : ju
    }), t;
  },
  selectNextDialog() {
    const e = Se.value.sort(
      (t, r) => t.zIndex > r.zIndex ? -1 : 1
    );
    e.length && or.focus(e[0].id);
  },
  remove(e = je.value) {
    if (e) {
      const t = Se.value.findIndex((r) => r.id === e);
      t > -1 && (Se.value.splice(t, 1), e === je.value && (je.value = void 0), or.selectNextDialog());
    }
  },
  focus(e) {
    const t = Se.value.find((r) => r.id === e);
    t && (je.value = e, t.zIndex !== Be.value && (Be.value++, t.zIndex = Be.value));
  },
  removeAll() {
    Se.value = [], Qt.value = ra, Be.value = aa, je.value = void 0;
  }
}, Uu = "fixed inset-0 flex justify-center items-start bg-neutral-quaternary bg-opacity-70 px-4 py-6 overflow-y-auto", Yu = "fixed top-1/2 flex w-fit h-fit justify-center items-start shadow-maxi rounded-md overflow-y-auto", Xu = "mx-4 text-neutral-secondary cursor-pointer flex items-center", Gu = "bg-neutral-secondary h-12 flex items-center justify-between px-4 border-neutral-tertiary", Ku = "bg-neutral-secondary h-12 flex items-center justify-between px-4 cursor-move border-neutral-tertiary", Zu = "m-auto w-fit min-w-[190px] bg-neutral-primary overflow-hidden lg:w-fit", Qu = 32, Er = 8, Ia = 4, Ju = ({
  x: e,
  windowWidth: t,
  dialogWidth: r,
  leftOffsetLimit: a,
  rightOffsetLimit: n,
  direction: o
}) => {
  const i = e > a, l = e < n, s = i ? l ? e : n : a;
  return {
    left: s,
    right: t - s - r
  }[o];
}, ed = ({
  y: e,
  topOffsetLimit: t,
  bottomOffsetLimit: r
}) => {
  const a = e > t, n = e < r;
  return a ? n ? e : r : t;
}, td = ({
  x: e,
  windowWidth: t,
  dialogWidth: r,
  direction: a
}) => r ? {
  left: r / 2 + e,
  right: t - (r / 2 + e)
}[a] : t / 2, rd = ({
  y: e,
  windowHeight: t,
  dialogHeight: r
}) => r ? r / 2 + e : t / 2, ad = ({
  centerX: e,
  prevDialogWidth: t,
  offset: r
}) => {
  const a = t / 2;
  return e - a - r;
}, nd = ({
  centerY: e,
  prevDialogHeight: t,
  offset: r
}) => {
  const a = t / 2;
  return e - a + r;
}, od = ({
  placement: e,
  referenceElement: t,
  dialogWidth: r
}) => {
  const a = e.includes("left") ? "left" : e.includes("right") ? "right" : "middle", { right: n, left: o } = t.getBoundingClientRect(), i = o + (n - o) / 2;
  return {
    right: n,
    middle: i - r / 2,
    left: o - r
  }[a];
}, ld = ({
  placement: e,
  referenceElement: t,
  dialogHeight: r
}) => {
  const a = e.includes("bottom") ? "bottom" : e.includes("top") ? "top" : "middle", { bottom: n, top: o } = t.getBoundingClientRect();
  return {
    bottom: n + Ia,
    middle: (n - o) / 2,
    top: o - r - Ia
  }[a];
};
function id({
  index: e,
  wrapperRef: t,
  draggableRef: r,
  referenceElementRef: a,
  placement: n,
  disableDragging: o
}) {
  const i = T(0), l = T(0), s = T(0), d = T(0), u = T(a ? 0 : e * Qu), c = T(!1), v = T(!1), p = E(() => a && "$el" in a ? a.$el : a), b = E(
    () => h.value - A.value - Er
  ), m = E(
    () => w.value - g.value
  ), { width: h, height: w } = Wr(), { width: A, height: C } = ar(t), { height: g } = ar(r), { direction: _ } = sd({
    x: i,
    referenceElement: p,
    placement: n,
    isDialogRendered: c
  }), O = (D) => Ju({
    x: D,
    windowWidth: h.value,
    dialogWidth: A.value,
    leftOffsetLimit: Er,
    rightOffsetLimit: b.value,
    direction: _.value
  }), y = (D) => ed({
    y: D,
    topOffsetLimit: Er,
    bottomOffsetLimit: m.value
  }), B = () => {
    let D;
    return a && !c.value ? D = od({
      placement: n,
      dialogWidth: A.value,
      referenceElement: p.value
    }) : D = ad({
      centerX: s.value,
      prevDialogWidth: A.value,
      offset: u.value
    }), O(D);
  }, S = () => {
    let D;
    return a && !c.value ? D = ld({
      placement: n,
      dialogHeight: C.value,
      referenceElement: p.value
    }) : D = nd({
      centerY: d.value,
      prevDialogHeight: C.value,
      offset: u.value
    }), y(D);
  }, N = (D) => {
    s.value = td({
      x: i.value,
      windowWidth: h.value,
      dialogWidth: D,
      direction: _.value
    }), i.value = B();
  }, M = (D) => {
    d.value = rd({
      y: l.value,
      windowHeight: w.value,
      dialogHeight: D
    }), l.value = S();
  }, F = (D, W) => {
    N(D), M(W), c.value || (c.value = !0, u.value = 0);
  };
  if (!o) {
    const { x: D, y: W } = ol(t, {
      handle: r,
      initialValue: {
        x: i.value,
        y: l.value
      },
      onStart() {
        v.value = !0;
      },
      onEnd() {
        v.value = !1;
      },
      onMove: () => {
        i.value = O(D.value), l.value = y(W.value);
      }
    });
  }
  return q([A, C], (D, [W, X]) => {
    F(W, X);
  }), q(_, () => {
    i.value = O(i.value);
  }), {
    x: i,
    y: l,
    direction: _,
    isDragging: v
  };
}
function sd({
  x: e,
  referenceElement: t,
  placement: r,
  isDialogRendered: a
}) {
  const n = T("left"), { width: o } = Wr(), i = E(() => o.value / 2), l = () => t && !a ? s() : d(), s = () => {
    const u = r.includes("left"), c = r.includes("right"), v = !u && !c, p = t.value.offsetLeft, b = t.value.offsetWidth;
    return u && p > i.value || c && p + b > i.value || v && p + b / 2 > i.value ? "right" : "left";
  }, d = () => n.value === "left" && e.value > i.value ? "right" : n.value === "right" && e.value > i.value ? "left" : n.value;
  return q(
    e,
    () => {
      setTimeout(() => {
        n.value = l();
      });
    },
    { immediate: !0 }
  ), {
    direction: n
  };
}
const it = /* @__PURE__ */ $({
  __name: "DynamicComponent",
  props: {
    content: {}
  },
  setup(e) {
    return (t, r) => typeof t.content == "string" ? (x(), P(f(J), {
      key: 0,
      weight: "bold",
      variant: "caption1"
    }, {
      default: V(() => [
        Q(ee(t.content), 1)
      ]),
      _: 1
    })) : (x(), P(lr(t.content.component), Un(ne({ key: 1 }, t.content.props)), null, 16));
  }
}), ud = { class: "relative" }, dd = ["id"], cd = { class: "flex items-center absolute z-10 left-3 top-3" }, fd = { key: 0 }, pd = $({ name: "NDialogItem", inheritAttrs: !1 }), vd = /* @__PURE__ */ $({
  ...pd,
  props: {
    id: {},
    zIndex: {},
    index: {},
    bodyClass: { default: "" },
    wrapperClass: { default: "" },
    footerClass: { default: "" },
    expandable: { type: Boolean, default: !1 },
    defaultExpanded: { type: Boolean, default: !1 },
    multiple: { type: Boolean, default: !1 },
    referenceElementRef: { default: void 0 },
    placement: { default: "bottom-left" },
    content: {},
    title: { default: "" },
    expandableLabel: { default: "" },
    expandedContent: { default: void 0 },
    footer: { default: void 0 }
  },
  emits: ["update:expanded", "afterOpen", "afterClose"],
  setup(e, { emit: t }) {
    const r = e, a = t, n = T(), o = T(), i = T(), l = T(), s = T(), d = T(), u = E(() => ({
      header: r.multiple ? Ku : Gu,
      expandable: Xu,
      wrapper: r.multiple ? Yu : Uu,
      dialog: Zu
    })), { x: c, y: v, direction: p, isDragging: b } = id({
      wrapperRef: r.multiple ? l : o,
      index: r.index,
      draggableRef: i,
      placement: r.placement,
      referenceElementRef: r.referenceElementRef,
      disableDragging: !r.multiple
    }), { remove: m, focus: h } = Cn(), [w, A] = ea(r.defaultExpanded), C = () => {
      a("afterClose"), m(r.id);
    }, g = () => {
      a("update:expanded", !w.value), A(!w.value);
    }, _ = () => {
      h(r.id);
    }, O = () => {
      r.multiple ? s.value = {
        [p.value]: `${c.value}px`,
        top: `${v.value}px`,
        zIndex: r.zIndex
      } : (r.referenceElementRef && (d.value = {
        [p.value]: `${c.value}px`,
        top: `${v.value}px`,
        zIndex: r.zIndex,
        position: "absolute"
      }), s.value = {
        zIndex: r.zIndex
      });
    };
    return q([c, v, () => r.zIndex], () => {
      O();
    }), (y, B) => (x(), P(f(cr), null, {
      default: V(() => [
        L("div", {
          ref_key: "wrapperRef",
          ref: l,
          class: k([u.value.wrapper, y.wrapperClass, { "opacity-20": f(b) }]),
          style: Ce(s.value),
          onMousedown: _
        }, [
          j(f(rr), {
            onAfterEnter: B[0] || (B[0] = (S) => a("afterOpen")),
            onAfterLeave: B[1] || (B[1] = (S) => a("afterClose"))
          }, {
            default: V(() => [
              j(f(Ue), ne(y.$attrs, {
                ref_key: "dialogRef",
                ref: o,
                "aria-labelledby": `${y.id}-label`,
                class: [u.value.dialog, y.bodyClass],
                style: d.value,
                elevation: "medium",
                role: "dialog",
                tabindex: "-1"
              }), {
                default: V(() => [
                  L("div", ud, [
                    L("div", {
                      ref_key: "headerRef",
                      ref: i,
                      class: k(u.value.header)
                    }, [
                      L("div", {
                        id: `${y.id}-label`,
                        class: k({
                          "rtl:ml-4 ltr:mr-4": !y.expandable,
                          invisible: f(b)
                        })
                      }, [
                        y.title ? (x(), P(it, {
                          key: 0,
                          content: y.title
                        }, null, 8, ["content"])) : z("", !0)
                      ], 10, dd)
                    ], 2),
                    L("div", cd, [
                      y.expandable ? (x(), I("div", {
                        key: 0,
                        class: k(u.value.expandable),
                        onClick: g
                      }, [
                        y.expandableLabel ? (x(), P(it, {
                          key: 0,
                          content: y.expandableLabel,
                          class: k({ invisible: f(b) })
                        }, null, 8, ["content", "class"])) : z("", !0),
                        j(f(Ro), {
                          class: k(["inline ltr:hidden", { "rotate-180": f(w) }])
                        }, null, 8, ["class"]),
                        j(f(Po), {
                          class: k(["inline rtl:hidden", { "rotate-180": f(w) }])
                        }, null, 8, ["class"])
                      ], 2)) : z("", !0),
                      j(f(ja), {
                        ref_key: "closeRef",
                        ref: n,
                        tabindex: "-1",
                        class: "cursor-pointer focus:outline-none",
                        onClick: C
                      }, null, 512)
                    ])
                  ]),
                  L("div", {
                    class: k(["p-4 flex gap-4", { invisible: f(b) }])
                  }, [
                    j(it, { content: y.content }, null, 8, ["content"]),
                    y.expandable && y.expandedContent ? Vr((x(), I("div", fd, [
                      j(it, { content: y.expandedContent }, null, 8, ["content"])
                    ], 512)), [
                      [Ma, f(w)]
                    ]) : z("", !0)
                  ], 2),
                  y.footer ? (x(), I("div", {
                    key: 0,
                    class: k(["p-4", [y.footerClass, { invisible: f(b) }]])
                  }, [
                    j(it, { content: y.footer }, null, 8, ["content"])
                  ], 2)) : z("", !0)
                ]),
                _: 1
              }, 16, ["aria-labelledby", "class", "style"])
            ]),
            _: 1
          })
        ], 38)
      ]),
      _: 1
    }));
  }
}), md = $({ name: "NDialog", inheritAttrs: !1 }), hd = /* @__PURE__ */ $({
  ...md,
  setup(e) {
    const { dialogs: t } = Cn();
    return (r, a) => (x(!0), I(he, null, Ge(f(t), (n) => (x(), P(vd, ne({
      key: n.id,
      dir: n.direction || "rtl",
      ref_for: !0
    }, n, {
      onAfterClose: n.afterClose,
      onAfterOpen: n.afterOpen,
      "onUpdate:expanded": n.onExpandedUpdate
    }), null, 16, ["dir", "onAfterClose", "onAfterOpen", "onUpdate:expanded"]))), 128));
  }
}), bd = (e, { appContext: t }) => {
  e.provide(Sn, or), e.config.globalProperties.$dialogs = or;
  const r = j(hd);
  r.appContext = { ...t }, Yn(r, document.body);
}, gd = { install: bd }, $n = Symbol("SliderContext");
function yd() {
  const e = ye($n);
  if (!e)
    throw new Error(
      "The useSliderContext hook must be used within <Slider /> component."
    );
  return e;
}
function wd(e, t, r) {
  const a = ue(t), n = T(0), o = T(0), i = T(), l = E(
    () => !a.disabled?.value && i.value === "right" && n.value < e.value.length - 1
  ), s = E(
    () => !a.disabled?.value && i.value === "left" && n.value > 0
  ), d = E(
    () => s.value || l.value
  ), u = E(
    () => e.value.length - 1 === n.value
  ), c = () => {
    n.value = Ve(Y.ArrowLeft)({
      currentIndex: n.value,
      total: e.value.length
    }), o.value = h.value * n.value;
  }, v = () => {
    n.value = Ve(Y.ArrowRight)({
      currentIndex: n.value,
      total: e.value.length
    }), o.value = h.value * n.value;
  }, p = (_) => {
    const O = _ - n.value;
    n.value = _, o.value += h.value * O;
  }, { pause: b, resume: m } = Jo(
    () => {
      u.value && !a.stopLoop.value ? p(0) : v();
    },
    a.duration?.value,
    { immediate: a.auto.value }
  ), { width: h } = ar(r), {
    lengthX: w,
    direction: A,
    isSwiping: C
  } = Ka(r, {
    threshold: 0,
    onSwipe() {
      (A.value === "left" || A.value === "right") && (i.value = A.value);
    },
    onSwipeEnd() {
      d.value ? Math.abs(w.value) > a.threshold.value ? (s.value && c(), l.value && v()) : o.value += w.value : a.disabled?.value || (w.value > 0 ? o.value = 0 : o.value = h.value * (e.value.length - 1));
    }
  });
  return q(h, (_, O) => {
    O !== 0 ? o.value += (_ - O) * n.value : p(a.modelValue.value);
  }), q(w, (_, O) => {
    d.value && _ !== 0 && (o.value += O - _);
  }), q(
    () => [a.disabled?.value, C.value, u.value],
    () => {
      a.disabled?.value || C.value || u.value && a.stopLoop.value ? b() : a.auto.value && !C.value && m();
    }
  ), Ae($n, {
    activeIndex: n
  }), {
    offsetX: o,
    activeIndex: n,
    activateSlide: p
  };
}
const xd = { class: "relative overflow-hidden w-full h-full" }, _d = ["onClick"], Ad = $({ name: "NSlider" }), Jt = /* @__PURE__ */ $({
  ...Ad,
  props: {
    modelValue: { default: 0 },
    showIndicators: { type: Boolean, default: !0 },
    indicatorsBottomOffset: { default: 8 },
    disabled: { type: Boolean, default: !1 },
    threshold: { default: 50 },
    auto: { type: Boolean, default: !1 },
    stopLoop: { type: Boolean, default: !1 },
    duration: { default: 5e3 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const r = e, a = t, n = T(), o = E(() => ({
      transform: `translateX(${s.value}px)`
    })), { descendants: i } = dr(), { activeIndex: l, offsetX: s, activateSlide: d } = wd(
      i,
      r,
      n
    );
    return q(
      () => r.modelValue,
      (u) => {
        d(u);
      }
    ), q(l, () => {
      a("update:modelValue", l.value);
    }), (u, c) => (x(), I("div", xd, [
      L("div", {
        ref_key: "swappableContainer",
        ref: n,
        dir: "rtl",
        class: "h-full w-full flex transition transition-gpu transform duration-150",
        style: Ce(o.value)
      }, [
        R(u.$slots, "default")
      ], 4),
      r.showIndicators && !r.disabled ? (x(), I("div", {
        key: 0,
        class: "flex absolute left-1/2 -translate-x-1/2 z-50",
        dir: "rtl",
        style: Ce({
          bottom: `${u.indicatorsBottomOffset}px`
        })
      }, [
        (x(!0), I(he, null, Ge(f(i).length, (v, p) => (x(), I("div", {
          key: p,
          class: k(["w-1 h-1 ml-1 last:ml-0 bg-neutral-primary rounded-full", {
            "!w-2": p === f(l),
            "bg-opacity-20": p !== f(l)
          }]),
          onClick: (b) => f(d)(p)
        }, null, 10, _d))), 128))
      ], 4)) : z("", !0)
    ]));
  }
});
Jt.install = (e) => {
  e.component(Jt.name, Jt);
};
const Ed = ["id", "tabindex"], Sd = $({ name: "NSliderItem" }), er = /* @__PURE__ */ $({
  ...Sd,
  setup(e) {
    const { activeIndex: t } = yd(), {
      ref: r,
      index: a,
      id: n
    } = ur({ idPrefix: "slider-item-" }), o = E(() => t.value === a.value);
    return (i, l) => (x(), I("div", {
      id: f(n),
      ref_key: "elementRef",
      ref: r,
      tabindex: o.value ? 0 : -1,
      class: "block shrink-0 w-full h-full",
      onTouchstart: l[0] || (l[0] = () => {
      })
    }, [
      R(i.$slots, "default")
    ], 40, Ed));
  }
});
er.install = (e) => {
  e.component(er.name, er);
};
var te = /* @__PURE__ */ ((e) => (e.success = "success", e.info = "info", e.error = "error", e.neutral = "neutral", e.warning = "warning", e))(te || {});
const Cd = "flex flex-col justify-between  p-2 rounded-md shadow-mini border border-neutral-tertiary", Da = {
  [te.success]: "bg-brand-secondary text-brand-primary",
  [te.error]: "bg-critical-secondary text-critical-secondary",
  [te.warning]: "bg-warning-secondary text-warning-primary",
  [te.info]: "bg-blue-secondary text-blue-primary",
  [te.neutral]: "bg-neutral-secondary text-neutral-primary"
}, $d = {
  [te.success]: "green",
  [te.error]: "gray",
  [te.warning]: "gray",
  [te.info]: "green",
  [te.neutral]: "green"
}, Td = {
  [te.success]: Ho,
  [te.error]: Mo,
  [te.warning]: Ua,
  [te.neutral]: ma,
  [te.info]: ma
}, Od = { class: "flex gap-2 items-start" }, Bd = $({ name: "NAlert" }), tr = /* @__PURE__ */ $({
  ...Bd,
  props: {
    message: { default: "" },
    variant: { default: "neutral" },
    showIcon: { type: Boolean, default: !1 },
    showButton: { type: Boolean, default: !1 },
    buttonLabel: { default: "" }
  },
  emits: ["onClick"],
  setup(e, { emit: t }) {
    const r = t, a = e, n = E(() => [
      Cd,
      a.variant ? Da[a.variant] : Da[te.neutral]
    ]);
    return (o, i) => (x(), I("div", {
      class: k(n.value)
    }, [
      L("div", Od, [
        L("div", null, [
          o.showIcon ? (x(), P(lr(f(Td)[a.variant]), {
            key: 0,
            size: "16",
            class: "mt-0.5"
          })) : z("", !0)
        ]),
        o.message ? (x(), P(f(J), {
          key: 0,
          class: "text-right",
          variant: "caption2",
          weight: "medium"
        }, {
          default: V(() => [
            Q(ee(o.message), 1)
          ]),
          _: 1
        })) : z("", !0)
      ]),
      o.showButton ? (x(), P(f(dt), {
        key: 0,
        color: f($d)[o.variant],
        size: "mini",
        variant: "plain",
        class: "self-end pr-0 pl-0",
        onClick: i[0] || (i[0] = (l) => r("onClick"))
      }, {
        default: V(() => [
          j(f(J), { variant: "overline" }, {
            default: V(() => [
              Q(ee(o.buttonLabel), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["color"])) : z("", !0)
    ], 2));
  }
});
tr.install = (e) => {
  e.component(tr.name, tr);
};
const kd = $({ name: "NDrop" });
function Ld(e, t, r, a, n, o) {
  return x(), P(Pr, {
    "enter-active-class": "transform transition-all ease-in duration-300",
    "leave-active-class": "transform transition-all ease-out duration-300",
    "enter-from-class": "opacity-0 -translate-y-2",
    "enter-to-class": "opacity-100 translate-y-0",
    "leave-from-class": "opacity-100 translate-y-0",
    "leave-to-class": "opacity-0 translate-y-2"
  }, {
    default: V(() => [
      R(e.$slots, "default")
    ]),
    _: 3
  });
}
const rr = /* @__PURE__ */ Hr(kd, [["render", Ld]]);
rr.install = (e) => {
  e.component(rr.name, rr);
};
const Sr = {
  Button: dt,
  ButtonToggle: It,
  ButtonToggleGroup: Dt,
  ButtonIcon: Nt,
  Heading: Rt,
  Text: J,
  Field: fr,
  Input: ct,
  Loading: ke,
  Progress: ft,
  BottomSheet: Pt,
  Radio: Mt,
  RadioGroup: zt,
  Checkbox: pt,
  CheckboxGroup: Vt,
  TransitionFade: cr,
  TransitionFadeBottom: ni,
  Toast: _i,
  Listbox: Ht,
  ListboxOption: Ft,
  Popper: ht,
  Box: Ue,
  Cheap: bt,
  Switch: Ut,
  Table: Gt,
  TableColumn: gt,
  Tabs: Kt,
  Tab: Zt,
  Dialog: gd,
  Slider: Jt,
  SliderItem: er,
  Alert: tr
};
function Id(e) {
  for (const t in Sr)
    e.component(Sr[t].name, Sr[t]);
}
const Nd = { install: Id };
export {
  tr as NAlert,
  Pt as NBottomSheet,
  Ue as NBox,
  dt as NButton,
  Nt as NButtonIcon,
  It as NButtonToggle,
  Dt as NButtonToggleGroup,
  bt as NCheap,
  pt as NCheckbox,
  Vt as NCheckboxGroup,
  gd as NDialog,
  fr as NField,
  Rt as NHeading,
  ct as NInput,
  Ht as NListbox,
  Ft as NListboxOption,
  ke as NLoading,
  ht as NPopper,
  ft as NProgress,
  Mt as NRadio,
  zt as NRadioGroup,
  Jt as NSlider,
  er as NSliderItem,
  Ut as NSwitch,
  Zt as NTab,
  Gt as NTable,
  gt as NTableColumn,
  Kt as NTabs,
  J as NText,
  _i as NToast,
  rr as NTransitionDrop,
  cr as NTransitionFade,
  ni as NTransitionFadeBottom,
  Nd as default,
  qr as locale,
  Cn as useDialog,
  oi as useToast
};
